export const mockFlightSearchResults = [
  {
    id: '1',
    from: 'London (LHR)',
    to: 'New York (JFK)',
    departureDate: '2025-09-15',
    returnDate: '2025-09-22',
    price: 450,
    airline: 'British Airways',
    airlineCode: 'BA',
    duration: '7h 30m',
    stops: 'Direct'
  },
  {
    id: '2',
    from: 'London (LHR)',
    to: 'Dubai (DXB)',
    departureDate: '2025-09-15',
    returnDate: '2025-09-22',
    price: 380,
    airline: 'Emirates',
    airlineCode: 'EK',
    duration: '6h 45m',
    stops: 'Direct'
  },
  {
    id: '3',
    from: 'London (LHR)',
    to: 'Singapore (SIN)',
    departureDate: '2025-09-15',
    returnDate: '2025-09-22',
    price: 620,
    airline: 'Singapore Airlines',
    airlineCode: 'SQ',
    duration: '13h 20m',
    stops: 'Direct'
  },
  {
    id: '4',
    from: 'London (LGW)',
    to: 'New York (JFK)',
    departureDate: '2025-09-15',
    returnDate: '2025-09-22',
    price: 420,
    airline: 'Virgin Atlantic',
    airlineCode: 'VS',
    duration: '8h 10m',
    stops: 'Direct'
  },
  {
    id: '5',
    from: 'London (STN)',
    to: 'Dubai (DXB)',
    departureDate: '2025-09-15',
    returnDate: '2025-09-22',
    price: 350,
    airline: 'Ryanair',
    airlineCode: 'FR',
    duration: '7h 15m',
    stops: '1 Stop'
  }
];

export const popularDestinations = [
  {
    id: '1',
    city: 'Paris',
    country: 'France',
    description: 'The city of lights and romance',
    price: 89,
    imageUrl: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&h=600&fit=crop'
  },
  {
    id: '2',
    city: 'Dubai',
    country: 'UAE',
    description: 'Luxury and modern architecture',
    price: 320,
    imageUrl: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&h=600&fit=crop'
  },
  {
    id: '3',
    city: 'New York',
    country: 'USA',
    description: 'The city that never sleeps',
    price: 380,
    imageUrl: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=800&h=600&fit=crop'
  },
  {
    id: '4',
    city: 'Tokyo',
    country: 'Japan',
    description: 'Where tradition meets innovation',
    price: 520,
    imageUrl: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=800&h=600&fit=crop'
  },
  {
    id: '5',
    city: 'Barcelona',
    country: 'Spain',
    description: 'Art, culture, and Mediterranean charm',
    price: 95,
    imageUrl: 'https://images.unsplash.com/photo-1583422409516-2895a77efded?w=800&h=600&fit=crop'
  },
  {
    id: '6',
    city: 'Bali',
    country: 'Indonesia',
    description: 'Tropical paradise and serene beaches',
    price: 480,
    imageUrl: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800&h=600&fit=crop'
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Sarah Johnson',
    role: 'Frequent Traveler',
    content: 'Flight380 made booking my family vacation so easy! Best prices and amazing customer service.',
    rating: 5
  },
  {
    id: '2',
    name: 'Michael Chen',
    role: 'Business Executive',
    content: 'I use Flight380 for all my business trips. The interface is clean and bookings are instant.',
    rating: 5
  },
  {
    id: '3',
    name: 'Emily Roberts',
    role: 'Travel Blogger',
    content: 'Found incredible deals to exotic destinations. Highly recommend for budget travelers!',
    rating: 5
  }
];

export const airlines = [
  // Major UK Airlines
  { code: 'BA', name: 'British Airways', country: 'United Kingdom' },
  { code: 'VS', name: 'Virgin Atlantic', country: 'United Kingdom' },
  { code: 'U2', name: 'easyJet', country: 'United Kingdom' },
  { code: 'BY', name: 'TUI Airways', country: 'United Kingdom' },
  { code: 'LS', name: 'Jet2.com', country: 'United Kingdom' },
  { code: 'ZT', name: 'Titan Airways', country: 'United Kingdom' },
  { code: 'MT', name: 'Thomas Cook Airlines', country: 'United Kingdom' },
  { code: 'BE', name: 'Flybe', country: 'United Kingdom' },
  { code: 'LM', name: 'Loganair', country: 'United Kingdom' },
  
  // Major European Airlines - Ireland
  { code: 'FR', name: 'Ryanair', country: 'Ireland' },
  { code: 'EI', name: 'Aer Lingus', country: 'Ireland' },
  
  // Major European Airlines - Germany
  { code: 'LH', name: 'Lufthansa', country: 'Germany' },
  { code: 'DE', name: 'Condor', country: 'Germany' },
  { code: 'EW', name: 'Eurowings', country: 'Germany' },
  { code: 'X3', name: 'TUIfly', country: 'Germany' },
  { code: '4U', name: 'Germanwings', country: 'Germany' },
  { code: 'AB', name: 'Air Berlin', country: 'Germany' },
  
  // Major European Airlines - France
  { code: 'AF', name: 'Air France', country: 'France' },
  { code: 'TO', name: 'Transavia France', country: 'France' },
  { code: 'A5', name: 'HOP!', country: 'France' },
  { code: 'SS', name: 'Corsair International', country: 'France' },
  { code: 'UU', name: 'Air Austral', country: 'France' },
  { code: 'BIE', name: 'Air Mediterranee', country: 'France' },
  
  // Major European Airlines - Netherlands
  { code: 'KL', name: 'KLM Royal Dutch Airlines', country: 'Netherlands' },
  { code: 'HV', name: 'Transavia', country: 'Netherlands' },
  
  // Major European Airlines - Spain
  { code: 'IB', name: 'Iberia', country: 'Spain' },
  { code: 'VY', name: 'Vueling', country: 'Spain' },
  { code: 'UX', name: 'Air Europa', country: 'Spain' },
  { code: 'NT', name: 'Binter Canarias', country: 'Spain' },
  { code: 'YW', name: 'Air Nostrum', country: 'Spain' },
  { code: 'I2', name: 'Iberia Express', country: 'Spain' },
  { code: 'EB', name: 'Wamos Air', country: 'Spain' },
  { code: 'PM', name: 'Plus Ultra Líneas Aéreas', country: 'Spain' },
  
  // Major European Airlines - Italy
  { code: 'AZ', name: 'ITA Airways', country: 'Italy' },
  { code: 'NO', name: 'Neos', country: 'Italy' },
  { code: 'BV', name: 'Blue Panorama Airlines', country: 'Italy' },
  { code: 'IG', name: 'Air Italy', country: 'Italy' },
  
  // Major European Airlines - Switzerland
  { code: 'LX', name: 'Swiss International Air Lines', country: 'Switzerland' },
  { code: 'GL', name: 'Air Greenland', country: 'Switzerland' },
  
  // Major European Airlines - Austria
  { code: 'OS', name: 'Austrian Airlines', country: 'Austria' },
  { code: 'VO', name: 'Tyrolean Airways', country: 'Austria' },
  
  // Major European Airlines - Belgium
  { code: 'SN', name: 'Brussels Airlines', country: 'Belgium' },
  { code: 'TB', name: 'TUI fly Belgium', country: 'Belgium' },
  
  // Major European Airlines - Portugal
  { code: 'TP', name: 'TAP Air Portugal', country: 'Portugal' },
  { code: 'NI', name: 'Portugalia Airlines', country: 'Portugal' },
  { code: 'S4', name: 'SATA Azores Airlines', country: 'Portugal' },
  
  // Major European Airlines - Scandinavia
  { code: 'SK', name: 'Scandinavian Airlines (SAS)', country: 'Scandinavia' },
  { code: 'DY', name: 'Norwegian Air Shuttle', country: 'Norway' },
  { code: 'D8', name: 'Norwegian Air International', country: 'Norway' },
  { code: 'WF', name: 'Wideroe', country: 'Norway' },
  { code: 'AY', name: 'Finnair', country: 'Finland' },
  { code: 'RC', name: 'Atlantic Airways', country: 'Faroe Islands' },
  { code: 'FI', name: 'Icelandair', country: 'Iceland' },
  { code: 'WW', name: 'WOW air', country: 'Iceland' },
  
  // Major European Airlines - Greece
  { code: 'A3', name: 'Aegean Airlines', country: 'Greece' },
  { code: 'OA', name: 'Olympic Air', country: 'Greece' },
  { code: 'GQ', name: 'Sky Express', country: 'Greece' },
  
  // Major European Airlines - Turkey
  { code: 'TK', name: 'Turkish Airlines', country: 'Turkey' },
  { code: 'PC', name: 'Pegasus Airlines', country: 'Turkey' },
  { code: 'XQ', name: 'SunExpress', country: 'Turkey' },
  { code: 'KK', name: 'AtlasGlobal', country: 'Turkey' },
  { code: '8Q', name: 'Onur Air', country: 'Turkey' },
  { code: 'XC', name: 'Corendon Airlines', country: 'Turkey' },
  { code: 'TM', name: 'AnadoluJet', country: 'Turkey' },
  
  // Major European Airlines - Eastern Europe
  { code: 'LO', name: 'LOT Polish Airlines', country: 'Poland' },
  { code: 'OK', name: 'Czech Airlines', country: 'Czech Republic' },
  { code: 'QS', name: 'SmartWings', country: 'Czech Republic' },
  { code: 'RO', name: 'Tarom', country: 'Romania' },
  { code: '0B', name: 'Blue Air', country: 'Romania' },
  { code: 'W6', name: 'Wizz Air', country: 'Hungary' },
  { code: 'FB', name: 'Bulgaria Air', country: 'Bulgaria' },
  { code: 'JP', name: 'Adria Airways', country: 'Slovenia' },
  { code: 'OU', name: 'Croatia Airlines', country: 'Croatia' },
  { code: 'JU', name: 'Air Serbia', country: 'Serbia' },
  { code: 'YM', name: 'Montenegro Airlines', country: 'Montenegro' },
  { code: 'BT', name: 'airBaltic', country: 'Latvia' },
  { code: 'BL', name: 'Pacific Airlines', country: 'Vietnam' },
  
  // Major European Airlines - Russia & CIS
  { code: 'SU', name: 'Aeroflot', country: 'Russia' },
  { code: 'S7', name: 'S7 Airlines', country: 'Russia' },
  { code: 'UT', name: 'UTair Aviation', country: 'Russia' },
  { code: 'U6', name: 'Ural Airlines', country: 'Russia' },
  { code: 'FV', name: 'Rossiya Airlines', country: 'Russia' },
  { code: 'DP', name: 'Pobeda', country: 'Russia' },
  { code: 'N4', name: 'Nordwind Airlines', country: 'Russia' },
  { code: '5N', name: 'Nordavia', country: 'Russia' },
  { code: 'PS', name: 'Ukraine International Airlines', country: 'Ukraine' },
  { code: 'B2', name: 'Belavia', country: 'Belarus' },
  { code: 'KC', name: 'Air Astana', country: 'Kazakhstan' },
  { code: 'HY', name: 'Uzbekistan Airways', country: 'Uzbekistan' },
  { code: 'J2', name: 'Azerbaijan Airlines', country: 'Azerbaijan' },
  { code: 'A9', name: 'Georgian Airways', country: 'Georgia' },
  { code: 'U8', name: 'Armavia', country: 'Armenia' },
  { code: 'T5', name: 'Turkmenistan Airlines', country: 'Turkmenistan' },
  { code: 'QH', name: 'Kyrgyzstan Air', country: 'Kyrgyzstan' },
  { code: '7J', name: 'Tajik Air', country: 'Tajikistan' },
  
  // Middle East - UAE
  { code: 'EK', name: 'Emirates', country: 'United Arab Emirates' },
  { code: 'EY', name: 'Etihad Airways', country: 'United Arab Emirates' },
  { code: 'FZ', name: 'flydubai', country: 'United Arab Emirates' },
  { code: 'G9', name: 'Air Arabia', country: 'United Arab Emirates' },
  
  // Middle East - Qatar
  { code: 'QR', name: 'Qatar Airways', country: 'Qatar' },
  
  // Middle East - Saudi Arabia
  { code: 'SV', name: 'Saudi Arabian Airlines', country: 'Saudi Arabia' },
  { code: 'XY', name: 'Flynas', country: 'Saudi Arabia' },
  { code: 'F3', name: 'Flyadeal', country: 'Saudi Arabia' },
  
  // Middle East - Kuwait
  { code: 'KU', name: 'Kuwait Airways', country: 'Kuwait' },
  { code: 'J9', name: 'Jazeera Airways', country: 'Kuwait' },
  
  // Middle East - Bahrain
  { code: 'GF', name: 'Gulf Air', country: 'Bahrain' },
  
  // Middle East - Oman
  { code: 'WY', name: 'Oman Air', country: 'Oman' },
  { code: 'OV', name: 'SalamAir', country: 'Oman' },
  
  // Middle East - Jordan
  { code: 'RJ', name: 'Royal Jordanian', country: 'Jordan' },
  
  // Middle East - Lebanon
  { code: 'ME', name: 'Middle East Airlines', country: 'Lebanon' },
  
  // Middle East - Israel
  { code: 'LY', name: 'El Al Israel Airlines', country: 'Israel' },
  { code: 'IZ', name: 'Arkia Israeli Airlines', country: 'Israel' },
  { code: '6H', name: 'Israir Airlines', country: 'Israel' },
  
  // Middle East - Iran
  { code: 'IR', name: 'Iran Air', country: 'Iran' },
  { code: 'EP', name: 'Mahan Air', country: 'Iran' },
  { code: 'I3', name: 'ATA Airlines', country: 'Iran' },
  { code: 'QB', name: 'Qeshm Air', country: 'Iran' },
  
  // Middle East - Iraq
  { code: 'IA', name: 'Iraqi Airways', country: 'Iraq' },
  { code: 'IF', name: 'Fly Baghdad', country: 'Iraq' },
  
  // Africa - North Africa
  { code: 'MS', name: 'EgyptAir', country: 'Egypt' },
  { code: 'SM', name: 'Air Cairo', country: 'Egypt' },
  { code: 'NP', name: 'Nile Air', country: 'Egypt' },
  { code: 'AT', name: 'Royal Air Maroc', country: 'Morocco' },
  { code: 'TU', name: 'Tunisair', country: 'Tunisia' },
  { code: '8U', name: 'Afriqiyah Airways', country: 'Libya' },
  { code: 'LN', name: 'Libyan Airlines', country: 'Libya' },
  { code: 'AH', name: 'Air Algerie', country: 'Algeria' },
  { code: 'MK', name: 'Air Mauritius', country: 'Mauritius' },
  
  // Africa - Sub-Saharan
  { code: 'SA', name: 'South African Airways', country: 'South Africa' },
  { code: 'FA', name: 'FlySafair', country: 'South Africa' },
  { code: 'MN', name: 'Kulula', country: 'South Africa' },
  { code: 'ET', name: 'Ethiopian Airlines', country: 'Ethiopia' },
  { code: 'KQ', name: 'Kenya Airways', country: 'Kenya' },
  { code: 'WB', name: 'RwandAir', country: 'Rwanda' },
  { code: 'TC', name: 'Air Tanzania', country: 'Tanzania' },
  { code: 'UM', name: 'Air Zimbabwe', country: 'Zimbabwe' },
  { code: 'QM', name: 'Air Malawi', country: 'Malawi' },
  { code: 'DT', name: 'TAAG Angola Airlines', country: 'Angola' },
  { code: 'TM', name: 'LAM Mozambique Airlines', country: 'Mozambique' },
  { code: 'SW', name: 'Air Namibia', country: 'Namibia' },
  { code: 'BP', name: 'Air Botswana', country: 'Botswana' },
  { code: 'HM', name: 'Air Seychelles', country: 'Seychelles' },
  { code: 'MD', name: 'Air Madagascar', country: 'Madagascar' },
  { code: 'WT', name: 'Nigeria Air', country: 'Nigeria' },
  { code: 'P4', name: 'Air Peace', country: 'Nigeria' },
  { code: 'W3', name: 'Arik Air', country: 'Nigeria' },
  { code: 'VK', name: 'Aero Contractors', country: 'Nigeria' },
  { code: 'GH', name: 'Ghana International Airlines', country: 'Ghana' },
  { code: 'HF', name: 'Air Côte d\'Ivoire', country: 'Ivory Coast' },
  { code: 'C3', name: 'Trade Air', country: 'Croatia' },
  { code: 'J7', name: 'Afrijet Business Service', country: 'Gabon' },
  { code: '5H', name: 'Five Forty Aviation', country: 'Kenya' },
  { code: 'JE', name: 'Mango Airlines', country: 'South Africa' },
  
  // Asia - Singapore
  { code: 'SQ', name: 'Singapore Airlines', country: 'Singapore' },
  { code: 'MI', name: 'SilkAir', country: 'Singapore' },
  { code: 'TR', name: 'Scoot', country: 'Singapore' },
  { code: '3K', name: 'Jetstar Asia Airways', country: 'Singapore' },
  
  // Asia - Japan
  { code: 'NH', name: 'All Nippon Airways (ANA)', country: 'Japan' },
  { code: 'JL', name: 'Japan Airlines', country: 'Japan' },
  { code: 'BC', name: 'Skymark Airlines', country: 'Japan' },
  { code: 'GK', name: 'Jetstar Japan', country: 'Japan' },
  { code: 'MM', name: 'Peach Aviation', country: 'Japan' },
  { code: 'IJ', name: 'Spring Airlines Japan', country: 'Japan' },
  { code: 'DJ', name: 'AirAsia Japan', country: 'Japan' },
  { code: 'HD', name: 'AIRDO', country: 'Japan' },
  { code: 'SJ', name: 'Sriwijaya Air', country: 'Indonesia' },
  { code: 'FW', name: 'Ibex Airlines', country: 'Japan' },
  { code: 'NU', name: 'Japan Transocean Air', country: 'Japan' },
  { code: '7G', name: 'Star Flyer', country: 'Japan' },
  
  // Asia - South Korea
  { code: 'KE', name: 'Korean Air', country: 'South Korea' },
  { code: 'OZ', name: 'Asiana Airlines', country: 'South Korea' },
  { code: 'LJ', name: 'Jin Air', country: 'South Korea' },
  { code: 'ZE', name: 'Eastar Jet', country: 'South Korea' },
  { code: 'TW', name: 'T\'way Air', country: 'South Korea' },
  { code: 'RS', name: 'Air Seoul', country: 'South Korea' },
  { code: 'BX', name: 'Air Busan', country: 'South Korea' },
  { code: '7C', name: 'Jeju Air', country: 'South Korea' },
  
  // Asia - China
  { code: 'CA', name: 'Air China', country: 'China' },
  { code: 'MU', name: 'China Eastern Airlines', country: 'China' },
  { code: 'CZ', name: 'China Southern Airlines', country: 'China' },
  { code: 'HU', name: 'Hainan Airlines', country: 'China' },
  { code: 'ZH', name: 'Shenzhen Airlines', country: 'China' },
  { code: 'MF', name: 'Xiamen Airlines', country: 'China' },
  { code: 'FM', name: 'Shanghai Airlines', country: 'China' },
  { code: '3U', name: 'Sichuan Airlines', country: 'China' },
  { code: 'SC', name: 'Shandong Airlines', country: 'China' },
  { code: 'HO', name: 'Juneyao Airlines', country: 'China' },
  { code: 'CN', name: 'Grand China Air', country: 'China' },
  { code: 'KN', name: 'China United Airlines', country: 'China' },
  { code: '8L', name: 'Lucky Air', country: 'China' },
  { code: 'TV', name: 'Tibet Airlines', country: 'China' },
  { code: 'GS', name: 'Tianjin Airlines', country: 'China' },
  { code: 'NS', name: 'Hebei Airlines', country: 'China' },
  { code: 'PN', name: 'West Air', country: 'China' },
  { code: 'DZ', name: 'Donghai Airlines', country: 'China' },
  { code: '9C', name: 'Spring Airlines', country: 'China' },
  { code: 'G5', name: 'China Express Airlines', country: 'China' },
  { code: 'EU', name: 'Chengdu Airlines', country: 'China' },
  { code: 'BK', name: 'Okay Airways', country: 'China' },
  { code: 'QW', name: 'Qingdao Airlines', country: 'China' },
  { code: 'UQ', name: 'Urumqi Air', country: 'China' },
  { code: 'DR', name: 'Ruili Airlines', country: 'China' },
  { code: 'JD', name: 'Beijing Capital Airlines', country: 'China' },
  
  // Asia - Hong Kong & Taiwan
  { code: 'CX', name: 'Cathay Pacific', country: 'Hong Kong' },
  { code: 'KA', name: 'Cathay Dragon', country: 'Hong Kong' },
  { code: 'HX', name: 'Hong Kong Airlines', country: 'Hong Kong' },
  { code: 'UO', name: 'HK Express', country: 'Hong Kong' },
  { code: 'CI', name: 'China Airlines', country: 'Taiwan' },
  { code: 'BR', name: 'EVA Air', country: 'Taiwan' },
  { code: 'GE', name: 'TransAsia Airways', country: 'Taiwan' },
  { code: 'IT', name: 'Tigerair Taiwan', country: 'Taiwan' },
  { code: 'B7', name: 'Uni Air', country: 'Taiwan' },
  { code: 'AE', name: 'Mandarin Airlines', country: 'Taiwan' },
  
  // Asia - Thailand
  { code: 'TG', name: 'Thai Airways', country: 'Thailand' },
  { code: 'FD', name: 'Thai AirAsia', country: 'Thailand' },
  { code: 'WE', name: 'Thai Smile', country: 'Thailand' },
  { code: 'DD', name: 'Nok Air', country: 'Thailand' },
  { code: 'SL', name: 'Thai Lion Air', country: 'Thailand' },
  { code: 'PG', name: 'Bangkok Airways', country: 'Thailand' },
  { code: 'OX', name: 'Orient Thai Airlines', country: 'Thailand' },
  
  // Asia - Malaysia
  { code: 'MH', name: 'Malaysia Airlines', country: 'Malaysia' },
  { code: 'AK', name: 'AirAsia', country: 'Malaysia' },
  { code: 'D7', name: 'AirAsia X', country: 'Malaysia' },
  { code: 'OD', name: 'Malindo Air', country: 'Malaysia' },
  { code: 'MJ', name: 'Myway Airlines', country: 'Malaysia' },
  
  // Asia - Indonesia
  { code: 'GA', name: 'Garuda Indonesia', country: 'Indonesia' },
  { code: 'QG', name: 'Citilink', country: 'Indonesia' },
  { code: 'QZ', name: 'Indonesia AirAsia', country: 'Indonesia' },
  { code: 'JT', name: 'Lion Air', country: 'Indonesia' },
  { code: 'IW', name: 'Wings Air', country: 'Indonesia' },
  { code: 'IN', name: 'Nam Air', country: 'Indonesia' },
  { code: 'ID', name: 'Batik Air', country: 'Indonesia' },
  { code: 'XT', name: 'Indonesia AirAsia X', country: 'Indonesia' },
  { code: 'XN', name: 'Xpress Air', country: 'Indonesia' },
  { code: 'IO', name: 'Indonesia Air Transport', country: 'Indonesia' },
  
  // Asia - Philippines
  { code: 'PR', name: 'Philippine Airlines', country: 'Philippines' },
  { code: '5J', name: 'Cebu Pacific', country: 'Philippines' },
  { code: 'Z2', name: 'AirAsia Zest', country: 'Philippines' },
  { code: 'DG', name: 'Cebgo', country: 'Philippines' },
  { code: 'P9', name: 'PAL Express', country: 'Philippines' },
  
  // Asia - Vietnam
  { code: 'VN', name: 'Vietnam Airlines', country: 'Vietnam' },
  { code: 'VJ', name: 'VietJet Air', country: 'Vietnam' },
  { code: 'QH', name: 'Bamboo Airways', country: 'Vietnam' },
  
  // Asia - India
  { code: 'AI', name: 'Air India', country: 'India' },
  { code: '6E', name: 'IndiGo', country: 'India' },
  { code: 'UK', name: 'Vistara', country: 'India' },
  { code: 'SG', name: 'SpiceJet', country: 'India' },
  { code: 'G8', name: 'Go First', country: 'India' },
  { code: 'I5', name: 'AirAsia India', country: 'India' },
  { code: 'QP', name: 'Akasa Air', country: 'India' },
  { code: '9W', name: 'Jet Airways', country: 'India' },
  { code: 'IX', name: 'Air India Express', country: 'India' },
  { code: '2T', name: 'TruJet', country: 'India' },
  { code: 'S5', name: 'Star Air', country: 'India' },
  { code: 'I7', name: 'Alliance Air', country: 'India' },
  
  // Asia - Pakistan
  { code: 'PK', name: 'Pakistan International Airlines', country: 'Pakistan' },
  { code: 'PA', name: 'Airblue', country: 'Pakistan' },
  { code: 'ER', name: 'Serene Air', country: 'Pakistan' },
  
  // Asia - Bangladesh
  { code: 'BG', name: 'Biman Bangladesh Airlines', country: 'Bangladesh' },
  { code: 'BS', name: 'US-Bangla Airlines', country: 'Bangladesh' },
  { code: 'VQ', name: 'Novoair', country: 'Bangladesh' },
  
  // Asia - Sri Lanka
  { code: 'UL', name: 'SriLankan Airlines', country: 'Sri Lanka' },
  
  // Asia - Nepal
  { code: 'RA', name: 'Nepal Airlines', country: 'Nepal' },
  { code: 'H9', name: 'Himalaya Airlines', country: 'Nepal' },
  { code: 'YT', name: 'Yeti Airlines', country: 'Nepal' },
  
  // Asia - Maldives
  { code: 'Q2', name: 'Maldivian', country: 'Maldives' },
  
  // Asia - Myanmar
  { code: 'UB', name: 'Myanmar National Airlines', country: 'Myanmar' },
  { code: '8M', name: 'Myanmar Airways International', country: 'Myanmar' },
  
  // Asia - Cambodia
  { code: 'K6', name: 'Cambodia Angkor Air', country: 'Cambodia' },
  
  // Asia - Laos
  { code: 'QV', name: 'Lao Airlines', country: 'Laos' },
  
  // Asia - Brunei
  { code: 'BI', name: 'Royal Brunei Airlines', country: 'Brunei' },
  
  // Asia - Mongolia
  { code: 'OM', name: 'MIAT Mongolian Airlines', country: 'Mongolia' },
  { code: 'MR', name: 'Hunnu Air', country: 'Mongolia' },
  
  // North America - USA Major
  { code: 'AA', name: 'American Airlines', country: 'United States' },
  { code: 'DL', name: 'Delta Air Lines', country: 'United States' },
  { code: 'UA', name: 'United Airlines', country: 'United States' },
  { code: 'WN', name: 'Southwest Airlines', country: 'United States' },
  { code: 'B6', name: 'JetBlue Airways', country: 'United States' },
  { code: 'AS', name: 'Alaska Airlines', country: 'United States' },
  { code: 'NK', name: 'Spirit Airlines', country: 'United States' },
  { code: 'F9', name: 'Frontier Airlines', country: 'United States' },
  { code: 'G4', name: 'Allegiant Air', country: 'United States' },
  { code: 'HA', name: 'Hawaiian Airlines', country: 'United States' },
  { code: 'SY', name: 'Sun Country Airlines', country: 'United States' },
  { code: 'VX', name: 'Virgin America', country: 'United States' },
  { code: 'MQ', name: 'Envoy Air', country: 'United States' },
  { code: 'OH', name: 'PSA Airlines', country: 'United States' },
  { code: 'YX', name: 'Republic Airways', country: 'United States' },
  { code: '9E', name: 'Endeavor Air', country: 'United States' },
  { code: 'OO', name: 'SkyWest Airlines', country: 'United States' },
  { code: 'EV', name: 'ExpressJet Airlines', country: 'United States' },
  { code: 'YV', name: 'Mesa Airlines', country: 'United States' },
  { code: 'KS', name: 'PenAir', country: 'United States' },
  { code: 'CP', name: 'Compass Airlines', country: 'United States' },
  { code: 'PT', name: 'Piedmont Airlines', country: 'United States' },
  { code: 'AX', name: 'Trans States Airlines', country: 'United States' },
  { code: 'ZW', name: 'Air Wisconsin', country: 'United States' },
  { code: 'C5', name: 'CommutAir', country: 'United States' },
  { code: 'MX', name: 'Breeze Airways', country: 'United States' },
  { code: 'XP', name: 'Avelo Airlines', country: 'United States' },
  
  // North America - Canada
  { code: 'AC', name: 'Air Canada', country: 'Canada' },
  { code: 'WS', name: 'WestJet', country: 'Canada' },
  { code: 'PD', name: 'Porter Airlines', country: 'Canada' },
  { code: 'WG', name: 'Sunwing Airlines', country: 'Canada' },
  { code: 'F8', name: 'Flair Airlines', country: 'Canada' },
  { code: '4N', name: 'Air North', country: 'Canada' },
  { code: 'QK', name: 'Jazz Aviation', country: 'Canada' },
  { code: '8P', name: 'Pacific Coastal Airlines', country: 'Canada' },
  { code: 'PB', name: 'Provincial Airlines', country: 'Canada' },
  { code: 'YN', name: 'Air Creebec', country: 'Canada' },
  { code: '2P', name: 'PAL Airlines', country: 'Canada' },
  { code: 'MO', name: 'Calm Air', country: 'Canada' },
  { code: '3H', name: 'Air Inuit', country: 'Canada' },
  
  // North America - Mexico
  { code: 'AM', name: 'Aeroméxico', country: 'Mexico' },
  { code: '5D', name: 'Aeromexico Connect', country: 'Mexico' },
  { code: 'Y4', name: 'Volaris', country: 'Mexico' },
  { code: '4O', name: 'Interjet', country: 'Mexico' },
  { code: 'VB', name: 'VivaAerobus', country: 'Mexico' },
  { code: 'MQ', name: 'Magnicharters', country: 'Mexico' },
  
  // Central America & Caribbean
  { code: 'CM', name: 'Copa Airlines', country: 'Panama' },
  { code: 'AV', name: 'Avianca', country: 'Colombia' },
  { code: 'TA', name: 'TACA Airlines', country: 'El Salvador' },
  { code: 'LR', name: 'LACSA', country: 'Costa Rica' },
  { code: 'GU', name: 'Aviateca', country: 'Guatemala' },
  { code: 'BW', name: 'Caribbean Airlines', country: 'Trinidad and Tobago' },
  { code: 'LI', name: 'LIAT', country: 'Antigua and Barbuda' },
  { code: 'JM', name: 'Air Jamaica', country: 'Jamaica' },
  { code: 'UP', name: 'Bahamasair', country: 'Bahamas' },
  { code: 'V3', name: 'Carpatair', country: 'Romania' },
  { code: '6Y', name: 'SmartLynx Airlines', country: 'Latvia' },
  { code: 'CU', name: 'Cubana de Aviación', country: 'Cuba' },
  { code: 'DO', name: 'Sky High Aviation', country: 'Dominican Republic' },
  { code: '9M', name: 'Central Mountain Air', country: 'Canada' },
  
  // South America
  { code: 'LA', name: 'LATAM Airlines', country: 'Chile' },
  { code: 'H2', name: 'LATAM Colombia', country: 'Colombia' },
  { code: 'XL', name: 'LATAM Ecuador', country: 'Ecuador' },
  { code: '4C', name: 'LATAM Argentina', country: 'Argentina' },
  { code: 'PZ', name: 'LATAM Paraguay', country: 'Paraguay' },
  { code: 'LP', name: 'LATAM Peru', country: 'Peru' },
  { code: 'AR', name: 'Aerolíneas Argentinas', country: 'Argentina' },
  { code: 'AU', name: 'Austral Líneas Aéreas', country: 'Argentina' },
  { code: 'AD', name: 'Azul Brazilian Airlines', country: 'Brazil' },
  { code: 'G3', name: 'GOL Linhas Aéreas', country: 'Brazil' },
  { code: 'JJ', name: 'LATAM Brasil', country: 'Brazil' },
  { code: 'O6', name: 'Avianca Brazil', country: 'Brazil' },
  { code: '2Z', name: 'VoePass', country: 'Brazil' },
  { code: 'R7', name: 'Aserca Airlines', country: 'Venezuela' },
  { code: 'V0', name: 'Conviasa', country: 'Venezuela' },
  { code: 'EQ', name: 'TAME', country: 'Ecuador' },
  { code: 'W4', name: 'Wingo', country: 'Colombia' },
  { code: 'VE', name: 'EasyFly', country: 'Colombia' },
  { code: 'P5', name: 'Copa Airlines Colombia', country: 'Colombia' },
  { code: '5L', name: 'Aerosur', country: 'Bolivia' },
  { code: 'OB', name: 'Boliviana de Aviación', country: 'Bolivia' },
  { code: 'PU', name: 'Plus Ultra Líneas Aéreas', country: 'Spain' },
  { code: '2K', name: 'Avianca Ecuador', country: 'Ecuador' },
  
  // Oceania - Australia
  { code: 'QF', name: 'Qantas', country: 'Australia' },
  { code: 'VA', name: 'Virgin Australia', country: 'Australia' },
  { code: 'JQ', name: 'Jetstar Airways', country: 'Australia' },
  { code: 'TT', name: 'Tigerair Australia', country: 'Australia' },
  { code: 'ZL', name: 'Regional Express', country: 'Australia' },
  { code: 'QQ', name: 'Alliance Airlines', country: 'Australia' },
  { code: 'FC', name: 'FlyPelican', country: 'Australia' },
  { code: 'CG', name: 'PNG Air', country: 'Papua New Guinea' },
  
  // Oceania - New Zealand
  { code: 'NZ', name: 'Air New Zealand', country: 'New Zealand' },
  { code: 'DJ', name: 'Virgin Blue', country: 'Australia' },
  
  // Oceania - Pacific Islands
  { code: 'FJ', name: 'Fiji Airways', country: 'Fiji' },
  { code: 'PX', name: 'Air Niugini', country: 'Papua New Guinea' },
  { code: 'NF', name: 'Air Vanuatu', country: 'Vanuatu' },
  { code: 'IE', name: 'Solomon Airlines', country: 'Solomon Islands' },
  { code: 'TN', name: 'Air Tahiti Nui', country: 'French Polynesia' },
  { code: 'SB', name: 'Aircalin', country: 'New Caledonia' },
  { code: 'NG', name: 'Air Kiribati', country: 'Kiribati' },
  { code: 'ON', name: 'Nauru Airlines', country: 'Nauru' },
  { code: 'KB', name: 'Druk Air', country: 'Bhutan' },
  
  // Cargo Airlines (commonly selected)
  { code: 'CV', name: 'Cargolux', country: 'Luxembourg' },
  { code: '5X', name: 'UPS Airlines', country: 'United States' },
  { code: 'FX', name: 'FedEx Express', country: 'United States' },
  { code: '5Y', name: 'Atlas Air', country: 'United States' },
  { code: 'PO', name: 'Polar Air Cargo', country: 'United States' },
  { code: 'K4', name: 'Kalitta Air', country: 'United States' },
  { code: 'GT', name: 'Air Guilin', country: 'China' },
  { code: 'RU', name: 'AirBridgeCargo', country: 'Russia' },
  { code: 'QT', name: 'Tampa Cargo', country: 'Colombia' },
  
  // Charter & Holiday Airlines
  { code: 'OR', name: 'TUI fly Netherlands', country: 'Netherlands' },
  { code: 'HQ', name: 'Thomas Cook Airlines Belgium', country: 'Belgium' },
  { code: 'XR', name: 'Corendon Dutch Airlines', country: 'Netherlands' },
  { code: 'BJ', name: 'Nouvelair Tunisie', country: 'Tunisia' },
  { code: 'J2', name: 'Jordan Aviation', country: 'Jordan' },
  
  // Low-Cost Carriers - Additional
  { code: 'DC', name: 'Braathens Regional', country: 'Sweden' },
  { code: '6P', name: 'Gryphon Airlines', country: 'United States' },
  { code: '8Z', name: 'Congo Airways', country: 'DR Congo' },
  { code: 'HG', name: 'Niki', country: 'Austria' },
  { code: 'NE', name: 'Nesma Airlines', country: 'Egypt' },
  { code: 'XW', name: 'NokScoot', country: 'Thailand' },
  { code: 'Z3', name: 'Zimex Aviation', country: 'Switzerland' }
];

export const features = [
  {
    id: '1',
    title: 'Best Price Guarantee',
    description: 'We compare prices across hundreds of airlines to ensure you get the best deal every time.',
    icon: 'BadgePoundSterling'
  },
  {
    id: '2',
    title: 'Instant Confirmation',
    description: 'Receive your booking confirmation instantly via email and SMS notification.',
    icon: 'Zap'
  },
  {
    id: '3',
    title: '24/7 Support',
    description: 'Our dedicated support team is available round the clock to assist with your travel needs.',
    icon: 'Headphones'
  },
  {
    id: '4',
    title: 'Flexible Booking',
    description: 'Change or cancel your booking easily with our flexible policies and options.',
    icon: 'CalendarClock'
  },
  {
    id: '5',
    title: 'Secure Payments',
    description: 'Your payment information is encrypted and secure with industry-leading security.',
    icon: 'Shield'
  },
  {
    id: '6',
    title: 'Loyalty Rewards',
    description: 'Earn points on every booking and redeem them for discounts on future flights.',
    icon: 'Gift'
  }
];

export const airports = [
  // United Kingdom - London Area
  { code: 'LHR', name: 'London Heathrow', city: 'London', country: 'United Kingdom' },
  { code: 'LGW', name: 'London Gatwick', city: 'London', country: 'United Kingdom' },
  { code: 'LTN', name: 'London Luton', city: 'London', country: 'United Kingdom' },
  { code: 'STN', name: 'London Stansted', city: 'London', country: 'United Kingdom' },
  { code: 'LCY', name: 'London City Airport', city: 'London', country: 'United Kingdom' },
  { code: 'SEN', name: 'London Southend', city: 'London', country: 'United Kingdom' },
  
  // United Kingdom - Other Cities
  { code: 'MAN', name: 'Manchester Airport', city: 'Manchester', country: 'United Kingdom' },
  { code: 'EDI', name: 'Edinburgh Airport', city: 'Edinburgh', country: 'United Kingdom' },
  { code: 'BHX', name: 'Birmingham Airport', city: 'Birmingham', country: 'United Kingdom' },
  { code: 'GLA', name: 'Glasgow Airport', city: 'Glasgow', country: 'United Kingdom' },
  { code: 'BRS', name: 'Bristol Airport', city: 'Bristol', country: 'United Kingdom' },
  { code: 'NCL', name: 'Newcastle Airport', city: 'Newcastle', country: 'United Kingdom' },
  { code: 'LBA', name: 'Leeds Bradford Airport', city: 'Leeds', country: 'United Kingdom' },
  { code: 'EMA', name: 'East Midlands Airport', city: 'Nottingham', country: 'United Kingdom' },
  { code: 'ABZ', name: 'Aberdeen Airport', city: 'Aberdeen', country: 'United Kingdom' },
  { code: 'BFS', name: 'Belfast International', city: 'Belfast', country: 'United Kingdom' },
  { code: 'LPL', name: 'Liverpool John Lennon Airport', city: 'Liverpool', country: 'United Kingdom' },
  { code: 'SOU', name: 'Southampton Airport', city: 'Southampton', country: 'United Kingdom' },
  { code: 'EXT', name: 'Exeter Airport', city: 'Exeter', country: 'United Kingdom' },
  { code: 'BHD', name: 'Belfast City Airport', city: 'Belfast', country: 'United Kingdom' },
  { code: 'INV', name: 'Inverness Airport', city: 'Inverness', country: 'United Kingdom' },
  { code: 'PIK', name: 'Glasgow Prestwick Airport', city: 'Glasgow', country: 'United Kingdom' },
  { code: 'CWL', name: 'Cardiff Airport', city: 'Cardiff', country: 'United Kingdom' },
  
  // United States - New York Area
  { code: 'JFK', name: 'John F Kennedy Intl', city: 'New York', country: 'United States' },
  { code: 'LGA', name: 'LaGuardia Airport', city: 'New York', country: 'United States' },
  { code: 'EWR', name: 'Newark Liberty Intl', city: 'New York', country: 'United States' },
  { code: 'HPN', name: 'Westchester County Airport', city: 'New York', country: 'United States' },
  { code: 'ISP', name: 'Long Island MacArthur Airport', city: 'New York', country: 'United States' },
  
  // United States - Los Angeles Area
  { code: 'LAX', name: 'Los Angeles Intl', city: 'Los Angeles', country: 'United States' },
  { code: 'BUR', name: 'Hollywood Burbank Airport', city: 'Los Angeles', country: 'United States' },
  { code: 'ONT', name: 'Ontario Intl', city: 'Los Angeles', country: 'United States' },
  { code: 'SNA', name: 'John Wayne Airport Orange County', city: 'Los Angeles', country: 'United States' },
  { code: 'LGB', name: 'Long Beach Airport', city: 'Los Angeles', country: 'United States' },
  
  // United States - San Francisco Bay Area
  { code: 'SFO', name: 'San Francisco Intl', city: 'San Francisco', country: 'United States' },
  { code: 'OAK', name: 'Oakland Intl', city: 'San Francisco', country: 'United States' },
  { code: 'SJC', name: 'San Jose Intl', city: 'San Francisco', country: 'United States' },
  
  // United States - Washington DC Area
  { code: 'DCA', name: 'Ronald Reagan Washington National', city: 'Washington DC', country: 'United States' },
  { code: 'IAD', name: 'Washington Dulles Intl', city: 'Washington DC', country: 'United States' },
  { code: 'BWI', name: 'Baltimore/Washington Intl', city: 'Washington DC', country: 'United States' },
  
  // United States - Chicago Area
  { code: 'ORD', name: 'Chicago O\'Hare Intl', city: 'Chicago', country: 'United States' },
  { code: 'MDW', name: 'Chicago Midway Intl', city: 'Chicago', country: 'United States' },
  
  // United States - Miami/Fort Lauderdale Area
  { code: 'MIA', name: 'Miami Intl', city: 'Miami', country: 'United States' },
  { code: 'FLL', name: 'Fort Lauderdale-Hollywood Intl', city: 'Miami', country: 'United States' },
  { code: 'PBI', name: 'Palm Beach Intl', city: 'Miami', country: 'United States' },
  
  // United States - Other Major Cities
  { code: 'ATL', name: 'Hartsfield-Jackson Atlanta Intl', city: 'Atlanta', country: 'United States' },
  { code: 'DFW', name: 'Dallas/Fort Worth Intl', city: 'Dallas', country: 'United States' },
  { code: 'DAL', name: 'Dallas Love Field', city: 'Dallas', country: 'United States' },
  { code: 'DEN', name: 'Denver Intl', city: 'Denver', country: 'United States' },
  { code: 'SEA', name: 'Seattle-Tacoma Intl', city: 'Seattle', country: 'United States' },
  { code: 'LAS', name: 'Las Vegas McCarran Intl', city: 'Las Vegas', country: 'United States' },
  { code: 'MCO', name: 'Orlando Intl', city: 'Orlando', country: 'United States' },
  { code: 'PHX', name: 'Phoenix Sky Harbor Intl', city: 'Phoenix', country: 'United States' },
  { code: 'IAH', name: 'Houston George Bush Intl', city: 'Houston', country: 'United States' },
  { code: 'HOU', name: 'Houston William P. Hobby Airport', city: 'Houston', country: 'United States' },
  { code: 'BOS', name: 'Boston Logan Intl', city: 'Boston', country: 'United States' },
  { code: 'MSP', name: 'Minneapolis-St Paul Intl', city: 'Minneapolis', country: 'United States' },
  { code: 'DTW', name: 'Detroit Metro Wayne County', city: 'Detroit', country: 'United States' },
  { code: 'PHL', name: 'Philadelphia Intl', city: 'Philadelphia', country: 'United States' },
  { code: 'SAN', name: 'San Diego Intl', city: 'San Diego', country: 'United States' },
  { code: 'TPA', name: 'Tampa Intl', city: 'Tampa', country: 'United States' },
  { code: 'PDX', name: 'Portland Intl', city: 'Portland', country: 'United States' },
  { code: 'HNL', name: 'Honolulu Daniel K. Inouye Intl', city: 'Honolulu', country: 'United States' },
  { code: 'STL', name: 'St. Louis Lambert Intl', city: 'St. Louis', country: 'United States' },
  { code: 'CLT', name: 'Charlotte Douglas Intl', city: 'Charlotte', country: 'United States' },
  { code: 'SLC', name: 'Salt Lake City Intl', city: 'Salt Lake City', country: 'United States' },
  { code: 'MSY', name: 'New Orleans Louis Armstrong Intl', city: 'New Orleans', country: 'United States' },
  { code: 'AUS', name: 'Austin-Bergstrom Intl', city: 'Austin', country: 'United States' },
  { code: 'RDU', name: 'Raleigh-Durham Intl', city: 'Raleigh', country: 'United States' },
  { code: 'SJU', name: 'San Juan Luis Muñoz Marín Intl', city: 'San Juan', country: 'United States' },
  
  // Canada
  { code: 'YYZ', name: 'Toronto Pearson Intl', city: 'Toronto', country: 'Canada' },
  { code: 'YTZ', name: 'Billy Bishop Toronto City Airport', city: 'Toronto', country: 'Canada' },
  { code: 'YVR', name: 'Vancouver Intl', city: 'Vancouver', country: 'Canada' },
  { code: 'YUL', name: 'Montreal Pierre Elliott Trudeau Intl', city: 'Montreal', country: 'Canada' },
  { code: 'YYC', name: 'Calgary Intl', city: 'Calgary', country: 'Canada' },
  { code: 'YOW', name: 'Ottawa Macdonald-Cartier Intl', city: 'Ottawa', country: 'Canada' },
  { code: 'YEG', name: 'Edmonton Intl', city: 'Edmonton', country: 'Canada' },
  { code: 'YHZ', name: 'Halifax Stanfield Intl', city: 'Halifax', country: 'Canada' },
  { code: 'YWG', name: 'Winnipeg James Armstrong Richardson Intl', city: 'Winnipeg', country: 'Canada' },
  
  // Europe - France (Paris Area)
  { code: 'CDG', name: 'Paris Charles de Gaulle', city: 'Paris', country: 'France' },
  { code: 'ORY', name: 'Paris Orly', city: 'Paris', country: 'France' },
  { code: 'BVA', name: 'Paris Beauvais-Tillé', city: 'Paris', country: 'France' },
  
  // Europe - France (Other Cities)
  { code: 'NCE', name: 'Nice Côte d\'Azur', city: 'Nice', country: 'France' },
  { code: 'LYS', name: 'Lyon Saint-Exupéry', city: 'Lyon', country: 'France' },
  { code: 'MRS', name: 'Marseille Provence', city: 'Marseille', country: 'France' },
  { code: 'TLS', name: 'Toulouse Blagnac', city: 'Toulouse', country: 'France' },
  { code: 'BOD', name: 'Bordeaux Mérignac', city: 'Bordeaux', country: 'France' },
  { code: 'NTE', name: 'Nantes Atlantique', city: 'Nantes', country: 'France' },
  
  // Europe - Germany (Berlin Area)
  { code: 'BER', name: 'Berlin Brandenburg', city: 'Berlin', country: 'Germany' },
  
  // Europe - Germany (Other Cities)
  { code: 'FRA', name: 'Frankfurt Airport', city: 'Frankfurt', country: 'Germany' },
  { code: 'MUC', name: 'Munich Airport', city: 'Munich', country: 'Germany' },
  { code: 'DUS', name: 'Düsseldorf Airport', city: 'Düsseldorf', country: 'Germany' },
  { code: 'HAM', name: 'Hamburg Airport', city: 'Hamburg', country: 'Germany' },
  { code: 'CGN', name: 'Cologne Bonn Airport', city: 'Cologne', country: 'Germany' },
  { code: 'STR', name: 'Stuttgart Airport', city: 'Stuttgart', country: 'Germany' },
  { code: 'NUE', name: 'Nuremberg Airport', city: 'Nuremberg', country: 'Germany' },
  
  // Europe - Spain
  { code: 'MAD', name: 'Madrid Barajas', city: 'Madrid', country: 'Spain' },
  { code: 'BCN', name: 'Barcelona El Prat', city: 'Barcelona', country: 'Spain' },
  { code: 'AGP', name: 'Málaga Costa del Sol', city: 'Málaga', country: 'Spain' },
  { code: 'PMI', name: 'Palma de Mallorca', city: 'Palma', country: 'Spain' },
  { code: 'SVQ', name: 'Sevilla Airport', city: 'Sevilla', country: 'Spain' },
  { code: 'VLC', name: 'Valencia Airport', city: 'Valencia', country: 'Spain' },
  { code: 'ALC', name: 'Alicante-Elche', city: 'Alicante', country: 'Spain' },
  { code: 'BIO', name: 'Bilbao Airport', city: 'Bilbao', country: 'Spain' },
  { code: 'TFN', name: 'Tenerife North Airport', city: 'Tenerife', country: 'Spain' },
  { code: 'TFS', name: 'Tenerife South Airport', city: 'Tenerife', country: 'Spain' },
  { code: 'LPA', name: 'Gran Canaria Airport', city: 'Gran Canaria', country: 'Spain' },
  { code: 'IBZ', name: 'Ibiza Airport', city: 'Ibiza', country: 'Spain' },
  
  // Europe - Italy (Rome Area)
  { code: 'FCO', name: 'Rome Fiumicino', city: 'Rome', country: 'Italy' },
  { code: 'CIA', name: 'Rome Ciampino', city: 'Rome', country: 'Italy' },
  
  // Europe - Italy (Milan Area)
  { code: 'MXP', name: 'Milan Malpensa', city: 'Milan', country: 'Italy' },
  { code: 'LIN', name: 'Milan Linate', city: 'Milan', country: 'Italy' },
  { code: 'BGY', name: 'Milan Bergamo Orio al Serio', city: 'Milan', country: 'Italy' },
  
  // Europe - Italy (Other Cities)
  { code: 'VCE', name: 'Venice Marco Polo', city: 'Venice', country: 'Italy' },
  { code: 'NAP', name: 'Naples Intl', city: 'Naples', country: 'Italy' },
  { code: 'PSA', name: 'Pisa Intl', city: 'Pisa', country: 'Italy' },
  { code: 'BLQ', name: 'Bologna Guglielmo Marconi', city: 'Bologna', country: 'Italy' },
  { code: 'FLR', name: 'Florence Airport', city: 'Florence', country: 'Italy' },
  { code: 'CTA', name: 'Catania Fontanarossa', city: 'Catania', country: 'Italy' },
  { code: 'PMO', name: 'Palermo Falcone-Borsellino', city: 'Palermo', country: 'Italy' },
  
  // Europe - Netherlands
  { code: 'AMS', name: 'Amsterdam Schiphol', city: 'Amsterdam', country: 'Netherlands' },
  { code: 'EIN', name: 'Eindhoven Airport', city: 'Eindhoven', country: 'Netherlands' },
  { code: 'RTM', name: 'Rotterdam The Hague Airport', city: 'Rotterdam', country: 'Netherlands' },
  
  // Europe - Switzerland
  { code: 'ZRH', name: 'Zurich Airport', city: 'Zurich', country: 'Switzerland' },
  { code: 'GVA', name: 'Geneva Airport', city: 'Geneva', country: 'Switzerland' },
  { code: 'BSL', name: 'Basel Mulhouse Freiburg', city: 'Basel', country: 'Switzerland' },
  { code: 'BRN', name: 'Bern Airport', city: 'Bern', country: 'Switzerland' },
  
  // Europe - Belgium
  { code: 'BRU', name: 'Brussels Airport', city: 'Brussels', country: 'Belgium' },
  { code: 'CRL', name: 'Brussels South Charleroi', city: 'Brussels', country: 'Belgium' },
  
  // Europe - Austria
  { code: 'VIE', name: 'Vienna Intl', city: 'Vienna', country: 'Austria' },
  { code: 'SZG', name: 'Salzburg Airport', city: 'Salzburg', country: 'Austria' },
  { code: 'INN', name: 'Innsbruck Airport', city: 'Innsbruck', country: 'Austria' },
  
  // Europe - Portugal
  { code: 'LIS', name: 'Lisbon Portela', city: 'Lisbon', country: 'Portugal' },
  { code: 'OPO', name: 'Porto Airport', city: 'Porto', country: 'Portugal' },
  { code: 'FAO', name: 'Faro Airport', city: 'Faro', country: 'Portugal' },
  { code: 'FNC', name: 'Funchal Madeira Airport', city: 'Funchal', country: 'Portugal' },
  
  // Europe - Greece
  { code: 'ATH', name: 'Athens Intl', city: 'Athens', country: 'Greece' },
  { code: 'HER', name: 'Heraklion Intl', city: 'Heraklion', country: 'Greece' },
  { code: 'RHO', name: 'Rhodes Intl', city: 'Rhodes', country: 'Greece' },
  { code: 'CFU', name: 'Corfu Intl', city: 'Corfu', country: 'Greece' },
  { code: 'SKG', name: 'Thessaloniki Macedonia Intl', city: 'Thessaloniki', country: 'Greece' },
  { code: 'JTR', name: 'Santorini Airport', city: 'Santorini', country: 'Greece' },
  { code: 'ZTH', name: 'Zakynthos Intl', city: 'Zakynthos', country: 'Greece' },
  { code: 'KGS', name: 'Kos Island Intl', city: 'Kos', country: 'Greece' },
  { code: 'JMK', name: 'Mykonos Airport', city: 'Mykonos', country: 'Greece' },
  
  // Europe - Turkey (Istanbul Area)
  { code: 'IST', name: 'Istanbul Airport', city: 'Istanbul', country: 'Turkey' },
  { code: 'SAW', name: 'Istanbul Sabiha Gökçen', city: 'Istanbul', country: 'Turkey' },
  
  // Europe - Turkey (Other Cities)
  { code: 'ESB', name: 'Ankara Esenboğa', city: 'Ankara', country: 'Turkey' },
  { code: 'AYT', name: 'Antalya Airport', city: 'Antalya', country: 'Turkey' },
  { code: 'ADB', name: 'Izmir Adnan Menderes', city: 'Izmir', country: 'Turkey' },
  { code: 'BJV', name: 'Bodrum Milas Airport', city: 'Bodrum', country: 'Turkey' },
  
  // Europe - Ireland
  { code: 'DUB', name: 'Dublin Airport', city: 'Dublin', country: 'Ireland' },
  { code: 'ORK', name: 'Cork Airport', city: 'Cork', country: 'Ireland' },
  { code: 'SNN', name: 'Shannon Airport', city: 'Shannon', country: 'Ireland' },
  
  // Europe - Scandinavia (Stockholm Area)
  { code: 'ARN', name: 'Stockholm Arlanda', city: 'Stockholm', country: 'Sweden' },
  { code: 'BMA', name: 'Stockholm Bromma', city: 'Stockholm', country: 'Sweden' },
  { code: 'NYO', name: 'Stockholm Skavsta', city: 'Stockholm', country: 'Sweden' },
  
  // Europe - Scandinavia (Other Cities)
  { code: 'CPH', name: 'Copenhagen Airport', city: 'Copenhagen', country: 'Denmark' },
  { code: 'OSL', name: 'Oslo Gardermoen', city: 'Oslo', country: 'Norway' },
  { code: 'HEL', name: 'Helsinki Vantaa', city: 'Helsinki', country: 'Finland' },
  { code: 'BGO', name: 'Bergen Airport', city: 'Bergen', country: 'Norway' },
  { code: 'GOT', name: 'Gothenburg Landvetter', city: 'Gothenburg', country: 'Sweden' },
  { code: 'TRD', name: 'Trondheim Værnes', city: 'Trondheim', country: 'Norway' },
  { code: 'AAL', name: 'Aalborg Airport', city: 'Aalborg', country: 'Denmark' },
  { code: 'BLL', name: 'Billund Airport', city: 'Billund', country: 'Denmark' },
  
  // Europe - Poland
  { code: 'WAW', name: 'Warsaw Chopin', city: 'Warsaw', country: 'Poland' },
  { code: 'KRK', name: 'Kraków John Paul II Intl', city: 'Kraków', country: 'Poland' },
  { code: 'GDN', name: 'Gdańsk Lech Wałęsa Airport', city: 'Gdańsk', country: 'Poland' },
  { code: 'WRO', name: 'Wrocław Copernicus Airport', city: 'Wrocław', country: 'Poland' },
  
  // Europe - Czech Republic
  { code: 'PRG', name: 'Prague Václav Havel', city: 'Prague', country: 'Czech Republic' },
  
  // Europe - Hungary
  { code: 'BUD', name: 'Budapest Ferenc Liszt Intl', city: 'Budapest', country: 'Hungary' },
  
  // Europe - Romania
  { code: 'OTP', name: 'Bucharest Henri Coandă Intl', city: 'Bucharest', country: 'Romania' },
  
  // Europe - Bulgaria
  { code: 'SOF', name: 'Sofia Airport', city: 'Sofia', country: 'Bulgaria' },
  { code: 'VAR', name: 'Varna Airport', city: 'Varna', country: 'Bulgaria' },
  { code: 'BOJ', name: 'Burgas Airport', city: 'Burgas', country: 'Bulgaria' },
  
  // Europe - Croatia
  { code: 'ZAG', name: 'Zagreb Airport', city: 'Zagreb', country: 'Croatia' },
  { code: 'DBV', name: 'Dubrovnik Airport', city: 'Dubrovnik', country: 'Croatia' },
  { code: 'SPU', name: 'Split Airport', city: 'Split', country: 'Croatia' },
  
  // Middle East - UAE (Dubai Area)
  { code: 'DXB', name: 'Dubai Intl', city: 'Dubai', country: 'UAE' },
  { code: 'DWC', name: 'Dubai World Central', city: 'Dubai', country: 'UAE' },
  { code: 'SHJ', name: 'Sharjah Intl', city: 'Sharjah', country: 'UAE' },
  
  // Middle East - UAE (Other)
  { code: 'AUH', name: 'Abu Dhabi Intl', city: 'Abu Dhabi', country: 'UAE' },
  { code: 'RKT', name: 'Ras Al Khaimah Intl', city: 'Ras Al Khaimah', country: 'UAE' },
  
  // Middle East - Qatar
  { code: 'DOH', name: 'Hamad Intl', city: 'Doha', country: 'Qatar' },
  
  // Middle East - Saudi Arabia
  { code: 'RUH', name: 'King Khalid Intl', city: 'Riyadh', country: 'Saudi Arabia' },
  { code: 'JED', name: 'King Abdulaziz Intl', city: 'Jeddah', country: 'Saudi Arabia' },
  { code: 'DMM', name: 'King Fahd Intl', city: 'Dammam', country: 'Saudi Arabia' },
  { code: 'MED', name: 'Prince Mohammad bin Abdulaziz Intl', city: 'Madinah', country: 'Saudi Arabia' },
  
  // Middle East - Israel
  { code: 'TLV', name: 'Ben Gurion Airport', city: 'Tel Aviv', country: 'Israel' },
  
  // Middle East - Jordan
  { code: 'AMM', name: 'Queen Alia Intl', city: 'Amman', country: 'Jordan' },
  
  // Middle East - Lebanon
  { code: 'BEY', name: 'Beirut Rafic Hariri Intl', city: 'Beirut', country: 'Lebanon' },
  
  // Middle East - Oman
  { code: 'MCT', name: 'Muscat Intl', city: 'Muscat', country: 'Oman' },
  
  // Middle East - Kuwait
  { code: 'KWI', name: 'Kuwait Intl', city: 'Kuwait City', country: 'Kuwait' },
  
  // Middle East - Bahrain
  { code: 'BAH', name: 'Bahrain Intl', city: 'Manama', country: 'Bahrain' },
  
  // Asia - Singapore
  { code: 'SIN', name: 'Singapore Changi', city: 'Singapore', country: 'Singapore' },
  
  // Asia - Japan (Tokyo Area)
  { code: 'HND', name: 'Tokyo Haneda', city: 'Tokyo', country: 'Japan' },
  { code: 'NRT', name: 'Tokyo Narita', city: 'Tokyo', country: 'Japan' },
  
  // Asia - Japan (Other Cities)
  { code: 'KIX', name: 'Osaka Kansai Intl', city: 'Osaka', country: 'Japan' },
  { code: 'ITM', name: 'Osaka Itami', city: 'Osaka', country: 'Japan' },
  { code: 'NGO', name: 'Nagoya Chubu Centrair', city: 'Nagoya', country: 'Japan' },
  { code: 'FUK', name: 'Fukuoka Airport', city: 'Fukuoka', country: 'Japan' },
  { code: 'CTS', name: 'Sapporo New Chitose', city: 'Sapporo', country: 'Japan' },
  { code: 'OKA', name: 'Naha Airport', city: 'Okinawa', country: 'Japan' },
  
  // Asia - China (Beijing Area)
  { code: 'PEK', name: 'Beijing Capital Intl', city: 'Beijing', country: 'China' },
  { code: 'PKX', name: 'Beijing Daxing Intl', city: 'Beijing', country: 'China' },
  
  // Asia - China (Shanghai Area)
  { code: 'PVG', name: 'Shanghai Pudong Intl', city: 'Shanghai', country: 'China' },
  { code: 'SHA', name: 'Shanghai Hongqiao Intl', city: 'Shanghai', country: 'China' },
  
  // Asia - China (Other Cities)
  { code: 'CAN', name: 'Guangzhou Baiyun Intl', city: 'Guangzhou', country: 'China' },
  { code: 'SZX', name: 'Shenzhen Bao\'an Intl', city: 'Shenzhen', country: 'China' },
  { code: 'CTU', name: 'Chengdu Shuangliu Intl', city: 'Chengdu', country: 'China' },
  { code: 'HGH', name: 'Hangzhou Xiaoshan Intl', city: 'Hangzhou', country: 'China' },
  { code: 'XIY', name: 'Xi\'an Xianyang Intl', city: 'Xi\'an', country: 'China' },
  { code: 'KMG', name: 'Kunming Changshui Intl', city: 'Kunming', country: 'China' },
  { code: 'CSX', name: 'Changsha Huanghua Intl', city: 'Changsha', country: 'China' },
  { code: 'WUH', name: 'Wuhan Tianhe Intl', city: 'Wuhan', country: 'China' },
  { code: 'NKG', name: 'Nanjing Lukou Intl', city: 'Nanjing', country: 'China' },
  
  // Asia - Hong Kong & Macau
  { code: 'HKG', name: 'Hong Kong Intl', city: 'Hong Kong', country: 'Hong Kong' },
  { code: 'MFM', name: 'Macau Intl', city: 'Macau', country: 'Macau' },
  
  // Asia - Taiwan
  { code: 'TPE', name: 'Taiwan Taoyuan Intl', city: 'Taipei', country: 'Taiwan' },
  { code: 'TSA', name: 'Taipei Songshan', city: 'Taipei', country: 'Taiwan' },
  { code: 'KHH', name: 'Kaohsiung Intl', city: 'Kaohsiung', country: 'Taiwan' },
  
  // Asia - South Korea (Seoul Area)
  { code: 'ICN', name: 'Seoul Incheon Intl', city: 'Seoul', country: 'South Korea' },
  { code: 'GMP', name: 'Seoul Gimpo Intl', city: 'Seoul', country: 'South Korea' },
  
  // Asia - South Korea (Other Cities)
  { code: 'PUS', name: 'Busan Gimhae Intl', city: 'Busan', country: 'South Korea' },
  { code: 'CJU', name: 'Jeju Intl', city: 'Jeju', country: 'South Korea' },
  
  // Asia - Thailand (Bangkok Area)
  { code: 'BKK', name: 'Bangkok Suvarnabhumi', city: 'Bangkok', country: 'Thailand' },
  { code: 'DMK', name: 'Bangkok Don Mueang Intl', city: 'Bangkok', country: 'Thailand' },
  
  // Asia - Thailand (Other Cities)
  { code: 'HKT', name: 'Phuket Intl', city: 'Phuket', country: 'Thailand' },
  { code: 'CNX', name: 'Chiang Mai Intl', city: 'Chiang Mai', country: 'Thailand' },
  { code: 'USM', name: 'Koh Samui Airport', city: 'Koh Samui', country: 'Thailand' },
  { code: 'HDY', name: 'Hat Yai Intl', city: 'Hat Yai', country: 'Thailand' },
  
  // Asia - Malaysia (Kuala Lumpur Area)
  { code: 'KUL', name: 'Kuala Lumpur Intl', city: 'Kuala Lumpur', country: 'Malaysia' },
  { code: 'SZB', name: 'Sultan Abdul Aziz Shah Airport', city: 'Kuala Lumpur', country: 'Malaysia' },
  
  // Asia - Malaysia (Other Cities)
  { code: 'PEN', name: 'Penang Intl', city: 'Penang', country: 'Malaysia' },
  { code: 'JHB', name: 'Johor Bahru Senai Intl', city: 'Johor Bahru', country: 'Malaysia' },
  { code: 'KCH', name: 'Kuching Intl', city: 'Kuching', country: 'Malaysia' },
  { code: 'BKI', name: 'Kota Kinabalu Intl', city: 'Kota Kinabalu', country: 'Malaysia' },
  { code: 'LGK', name: 'Langkawi Intl', city: 'Langkawi', country: 'Malaysia' },
  
  // Asia - Indonesia (Jakarta Area)
  { code: 'CGK', name: 'Jakarta Soekarno-Hatta Intl', city: 'Jakarta', country: 'Indonesia' },
  { code: 'HLP', name: 'Jakarta Halim Perdanakusuma', city: 'Jakarta', country: 'Indonesia' },
  
  // Asia - Indonesia (Other Cities)
  { code: 'DPS', name: 'Bali Ngurah Rai Intl', city: 'Bali', country: 'Indonesia' },
  { code: 'SUB', name: 'Surabaya Juanda Intl', city: 'Surabaya', country: 'Indonesia' },
  { code: 'UPG', name: 'Makassar Sultan Hasanuddin Intl', city: 'Makassar', country: 'Indonesia' },
  { code: 'MDC', name: 'Manado Sam Ratulangi Intl', city: 'Manado', country: 'Indonesia' },
  { code: 'JOG', name: 'Yogyakarta Adisucipto Intl', city: 'Yogyakarta', country: 'Indonesia' },
  
  // Asia - Vietnam
  { code: 'SGN', name: 'Ho Chi Minh City Tan Son Nhat', city: 'Ho Chi Minh City', country: 'Vietnam' },
  { code: 'HAN', name: 'Hanoi Noi Bai Intl', city: 'Hanoi', country: 'Vietnam' },
  { code: 'DAD', name: 'Da Nang Intl', city: 'Da Nang', country: 'Vietnam' },
  { code: 'CXR', name: 'Cam Ranh Intl', city: 'Nha Trang', country: 'Vietnam' },
  { code: 'PQC', name: 'Phu Quoc Intl', city: 'Phu Quoc', country: 'Vietnam' },
  
  // Asia - Philippines (Manila Area)
  { code: 'MNL', name: 'Manila Ninoy Aquino Intl', city: 'Manila', country: 'Philippines' },
  { code: 'CRK', name: 'Clark Intl', city: 'Manila', country: 'Philippines' },
  
  // Asia - Philippines (Other Cities)
  { code: 'CEB', name: 'Cebu Mactan Intl', city: 'Cebu', country: 'Philippines' },
  { code: 'DVO', name: 'Davao Francisco Bangoy Intl', city: 'Davao', country: 'Philippines' },
  { code: 'ILO', name: 'Iloilo Intl', city: 'Iloilo', country: 'Philippines' },
  { code: 'MPH', name: 'Caticlan (Boracay)', city: 'Caticlan', country: 'Philippines' },
  
  // Asia - India (Mumbai Area)
  { code: 'BOM', name: 'Mumbai Chhatrapati Shivaji Intl', city: 'Mumbai', country: 'India' },
  
  // Asia - India (Delhi Area)
  { code: 'DEL', name: 'Delhi Indira Gandhi Intl', city: 'Delhi', country: 'India' },
  
  // Asia - India (Other Cities)
  { code: 'BLR', name: 'Bengaluru Kempegowda Intl', city: 'Bengaluru', country: 'India' },
  { code: 'HYD', name: 'Hyderabad Rajiv Gandhi Intl', city: 'Hyderabad', country: 'India' },
  { code: 'MAA', name: 'Chennai Intl', city: 'Chennai', country: 'India' },
  { code: 'CCU', name: 'Kolkata Netaji Subhas Chandra Bose Intl', city: 'Kolkata', country: 'India' },
  { code: 'GOI', name: 'Goa Dabolim Airport', city: 'Goa', country: 'India' },
  { code: 'COK', name: 'Kochi Intl', city: 'Kochi', country: 'India' },
  { code: 'AMD', name: 'Ahmedabad Sardar Vallabhbhai Patel Intl', city: 'Ahmedabad', country: 'India' },
  { code: 'PNQ', name: 'Pune Airport', city: 'Pune', country: 'India' },
  { code: 'JAI', name: 'Jaipur Intl', city: 'Jaipur', country: 'India' },
  
  // Asia - Pakistan
  { code: 'KHI', name: 'Karachi Jinnah Intl', city: 'Karachi', country: 'Pakistan' },
  { code: 'LHE', name: 'Lahore Allama Iqbal Intl', city: 'Lahore', country: 'Pakistan' },
  { code: 'ISB', name: 'Islamabad Intl', city: 'Islamabad', country: 'Pakistan' },
  
  // Asia - Bangladesh
  { code: 'DAC', name: 'Dhaka Hazrat Shahjalal Intl', city: 'Dhaka', country: 'Bangladesh' },
  
  // Asia - Sri Lanka
  { code: 'CMB', name: 'Colombo Bandaranaike Intl', city: 'Colombo', country: 'Sri Lanka' },
  
  // Asia - Nepal
  { code: 'KTM', name: 'Kathmandu Tribhuvan Intl', city: 'Kathmandu', country: 'Nepal' },
  
  // Asia - Maldives
  { code: 'MLE', name: 'Malé Velana Intl', city: 'Malé', country: 'Maldives' },
  
  // Australia & Oceania (Sydney Area)
  { code: 'SYD', name: 'Sydney Kingsford Smith', city: 'Sydney', country: 'Australia' },
  
  // Australia & Oceania (Melbourne Area)
  { code: 'MEL', name: 'Melbourne Tullamarine', city: 'Melbourne', country: 'Australia' },
  { code: 'AVV', name: 'Melbourne Avalon', city: 'Melbourne', country: 'Australia' },
  
  // Australia & Oceania (Other Cities)
  { code: 'BNE', name: 'Brisbane Airport', city: 'Brisbane', country: 'Australia' },
  { code: 'PER', name: 'Perth Airport', city: 'Perth', country: 'Australia' },
  { code: 'ADL', name: 'Adelaide Airport', city: 'Adelaide', country: 'Australia' },
  { code: 'CNS', name: 'Cairns Airport', city: 'Cairns', country: 'Australia' },
  { code: 'OOL', name: 'Gold Coast Airport', city: 'Gold Coast', country: 'Australia' },
  { code: 'DRW', name: 'Darwin Intl', city: 'Darwin', country: 'Australia' },
  { code: 'HBA', name: 'Hobart Airport', city: 'Hobart', country: 'Australia' },
  { code: 'AKL', name: 'Auckland Airport', city: 'Auckland', country: 'New Zealand' },
  { code: 'WLG', name: 'Wellington Airport', city: 'Wellington', country: 'New Zealand' },
  { code: 'CHC', name: 'Christchurch Airport', city: 'Christchurch', country: 'New Zealand' },
  { code: 'ZQN', name: 'Queenstown Airport', city: 'Queenstown', country: 'New Zealand' },
  { code: 'NAN', name: 'Nadi Intl', city: 'Nadi', country: 'Fiji' },
  { code: 'PPT', name: 'Faa\'a Intl Tahiti', city: 'Papeete', country: 'French Polynesia' },
  
  // Africa - South Africa
  { code: 'JNB', name: 'Johannesburg OR Tambo Intl', city: 'Johannesburg', country: 'South Africa' },
  { code: 'CPT', name: 'Cape Town Intl', city: 'Cape Town', country: 'South Africa' },
  { code: 'DUR', name: 'Durban King Shaka Intl', city: 'Durban', country: 'South Africa' },
  
  // Africa - Egypt
  { code: 'CAI', name: 'Cairo Intl', city: 'Cairo', country: 'Egypt' },
  { code: 'HRG', name: 'Hurghada Intl', city: 'Hurghada', country: 'Egypt' },
  { code: 'SSH', name: 'Sharm El Sheikh Intl', city: 'Sharm El Sheikh', country: 'Egypt' },
  { code: 'LXR', name: 'Luxor Intl', city: 'Luxor', country: 'Egypt' },
  
  // Africa - Morocco
  { code: 'CMN', name: 'Casablanca Mohammed V Intl', city: 'Casablanca', country: 'Morocco' },
  { code: 'RAK', name: 'Marrakech Menara', city: 'Marrakech', country: 'Morocco' },
  { code: 'AGA', name: 'Agadir Al Massira', city: 'Agadir', country: 'Morocco' },
  { code: 'FEZ', name: 'Fez Saïss Airport', city: 'Fez', country: 'Morocco' },
  
  // Africa - Kenya
  { code: 'NBO', name: 'Nairobi Jomo Kenyatta Intl', city: 'Nairobi', country: 'Kenya' },
  { code: 'MBA', name: 'Mombasa Moi Intl', city: 'Mombasa', country: 'Kenya' },
  
  // Africa - Tanzania
  { code: 'DAR', name: 'Dar es Salaam Julius Nyerere Intl', city: 'Dar es Salaam', country: 'Tanzania' },
  { code: 'JRO', name: 'Kilimanjaro Intl', city: 'Kilimanjaro', country: 'Tanzania' },
  { code: 'ZNZ', name: 'Zanzibar Abeid Amani Karume Intl', city: 'Zanzibar', country: 'Tanzania' },
  
  // Africa - Nigeria
  { code: 'LOS', name: 'Lagos Murtala Muhammed Intl', city: 'Lagos', country: 'Nigeria' },
  { code: 'ABV', name: 'Abuja Nnamdi Azikiwe Intl', city: 'Abuja', country: 'Nigeria' },
  
  // Africa - Ethiopia
  { code: 'ADD', name: 'Addis Ababa Bole Intl', city: 'Addis Ababa', country: 'Ethiopia' },
  
  // Africa - Ghana
  { code: 'ACC', name: 'Accra Kotoka Intl', city: 'Accra', country: 'Ghana' },
  
  // Africa - Tunisia
  { code: 'TUN', name: 'Tunis Carthage Intl', city: 'Tunis', country: 'Tunisia' },
  
  // South America - Brazil (São Paulo Area)
  { code: 'GRU', name: 'São Paulo Guarulhos Intl', city: 'São Paulo', country: 'Brazil' },
  { code: 'CGH', name: 'São Paulo Congonhas', city: 'São Paulo', country: 'Brazil' },
  { code: 'VCP', name: 'Campinas Viracopos Intl', city: 'São Paulo', country: 'Brazil' },
  
  // South America - Brazil (Rio Area)
  { code: 'GIG', name: 'Rio de Janeiro Galeão Intl', city: 'Rio de Janeiro', country: 'Brazil' },
  { code: 'SDU', name: 'Rio de Janeiro Santos Dumont', city: 'Rio de Janeiro', country: 'Brazil' },
  
  // South America - Brazil (Other Cities)
  { code: 'BSB', name: 'Brasília Intl', city: 'Brasília', country: 'Brazil' },
  { code: 'CNF', name: 'Belo Horizonte Confins Intl', city: 'Belo Horizonte', country: 'Brazil' },
  { code: 'SSA', name: 'Salvador Deputado Luís Eduardo Magalhães Intl', city: 'Salvador', country: 'Brazil' },
  { code: 'FOR', name: 'Fortaleza Pinto Martins Intl', city: 'Fortaleza', country: 'Brazil' },
  { code: 'REC', name: 'Recife Guararapes Intl', city: 'Recife', country: 'Brazil' },
  
  // South America - Argentina (Buenos Aires Area)
  { code: 'EZE', name: 'Buenos Aires Ezeiza Intl', city: 'Buenos Aires', country: 'Argentina' },
  { code: 'AEP', name: 'Buenos Aires Jorge Newbery', city: 'Buenos Aires', country: 'Argentina' },
  
  // South America - Chile
  { code: 'SCL', name: 'Santiago Arturo Merino Benítez Intl', city: 'Santiago', country: 'Chile' },
  
  // South America - Peru
  { code: 'LIM', name: 'Lima Jorge Chávez Intl', city: 'Lima', country: 'Peru' },
  { code: 'CUZ', name: 'Cusco Alejandro Velasco Astete Intl', city: 'Cusco', country: 'Peru' },
  
  // South America - Colombia
  { code: 'BOG', name: 'Bogotá El Dorado Intl', city: 'Bogotá', country: 'Colombia' },
  { code: 'MDE', name: 'Medellín José María Córdova Intl', city: 'Medellín', country: 'Colombia' },
  { code: 'CTG', name: 'Cartagena Rafael Núñez Intl', city: 'Cartagena', country: 'Colombia' },
  { code: 'CLO', name: 'Cali Alfonso Bonilla Aragón Intl', city: 'Cali', country: 'Colombia' },
  
  // South America - Ecuador
  { code: 'UIO', name: 'Quito Mariscal Sucre Intl', city: 'Quito', country: 'Ecuador' },
  { code: 'GYE', name: 'Guayaquil José Joaquín de Olmedo Intl', city: 'Guayaquil', country: 'Ecuador' },
  
  // South America - Venezuela
  { code: 'CCS', name: 'Caracas Simón Bolívar Intl', city: 'Caracas', country: 'Venezuela' },
  
  // Central America & Caribbean (Mexico)
  { code: 'MEX', name: 'Mexico City Intl', city: 'Mexico City', country: 'Mexico' },
  { code: 'CUN', name: 'Cancún Intl', city: 'Cancún', country: 'Mexico' },
  { code: 'GDL', name: 'Guadalajara Miguel Hidalgo y Costilla Intl', city: 'Guadalajara', country: 'Mexico' },
  { code: 'TIJ', name: 'Tijuana Intl', city: 'Tijuana', country: 'Mexico' },
  { code: 'MTY', name: 'Monterrey Gen. Mariano Escobedo Intl', city: 'Monterrey', country: 'Mexico' },
  { code: 'PVR', name: 'Puerto Vallarta Gustavo Díaz Ordaz Intl', city: 'Puerto Vallarta', country: 'Mexico' },
  { code: 'SJD', name: 'Los Cabos Intl', city: 'Los Cabos', country: 'Mexico' },
  { code: 'MID', name: 'Mérida Manuel Crescencio Rejón Intl', city: 'Mérida', country: 'Mexico' },
  
  // Central America & Caribbean (Other Countries)
  { code: 'PTY', name: 'Panama City Tocumen Intl', city: 'Panama City', country: 'Panama' },
  { code: 'SJO', name: 'San José Juan Santamaría Intl', city: 'San José', country: 'Costa Rica' },
  { code: 'LIR', name: 'Liberia Daniel Oduber Quirós Intl', city: 'Liberia', country: 'Costa Rica' },
  { code: 'SAL', name: 'San Salvador El Salvador Intl', city: 'San Salvador', country: 'El Salvador' },
  { code: 'GUA', name: 'Guatemala City La Aurora Intl', city: 'Guatemala City', country: 'Guatemala' },
  { code: 'MBJ', name: 'Montego Bay Sangster Intl', city: 'Montego Bay', country: 'Jamaica' },
  { code: 'KIN', name: 'Kingston Norman Manley Intl', city: 'Kingston', country: 'Jamaica' },
  { code: 'NAS', name: 'Nassau Lynden Pindling Intl', city: 'Nassau', country: 'Bahamas' },
  { code: 'PUJ', name: 'Punta Cana Intl', city: 'Punta Cana', country: 'Dominican Republic' },
  { code: 'SDQ', name: 'Santo Domingo Las Américas Intl', city: 'Santo Domingo', country: 'Dominican Republic' },
  { code: 'HAV', name: 'Havana José Martí Intl', city: 'Havana', country: 'Cuba' },
  { code: 'AUA', name: 'Aruba Queen Beatrix Intl', city: 'Aruba', country: 'Aruba' },
  { code: 'CUR', name: 'Curaçao Hato Intl', city: 'Curaçao', country: 'Curaçao' },
  { code: 'BGI', name: 'Bridgetown Grantley Adams Intl', city: 'Bridgetown', country: 'Barbados' },

  // Additional UK Airports
  { code: 'DSA', name: 'Doncaster Sheffield Airport', city: 'Doncaster', country: 'United Kingdom' },
  { code: 'NQY', name: 'Newquay Cornwall Airport', city: 'Newquay', country: 'United Kingdom' },
  { code: 'BOH', name: 'Bournemouth Airport', city: 'Bournemouth', country: 'United Kingdom' },
  { code: 'HUY', name: 'Humberside Airport', city: 'Humberside', country: 'United Kingdom' },
  { code: 'NWI', name: 'Norwich Airport', city: 'Norwich', country: 'United Kingdom' },
  { code: 'IOM', name: 'Isle of Man Airport', city: 'Isle of Man', country: 'United Kingdom' },
  { code: 'JER', name: 'Jersey Airport', city: 'Jersey', country: 'United Kingdom' },
  { code: 'GCI', name: 'Guernsey Airport', city: 'Guernsey', country: 'United Kingdom' },

  // Russia
  { code: 'SVO', name: 'Moscow Sheremetyevo Intl', city: 'Moscow', country: 'Russia' },
  { code: 'DME', name: 'Moscow Domodedovo Intl', city: 'Moscow', country: 'Russia' },
  { code: 'VKO', name: 'Moscow Vnukovo Intl', city: 'Moscow', country: 'Russia' },
  { code: 'LED', name: 'St Petersburg Pulkovo', city: 'St Petersburg', country: 'Russia' },
  { code: 'KZN', name: 'Kazan Intl Airport', city: 'Kazan', country: 'Russia' },
  { code: 'SVX', name: 'Yekaterinburg Koltsovo', city: 'Yekaterinburg', country: 'Russia' },
  { code: 'OVB', name: 'Novosibirsk Tolmachevo', city: 'Novosibirsk', country: 'Russia' },
  { code: 'KRR', name: 'Krasnodar Pashkovsky', city: 'Krasnodar', country: 'Russia' },
  { code: 'ROV', name: 'Rostov-on-Don Platov', city: 'Rostov-on-Don', country: 'Russia' },
  { code: 'AER', name: 'Sochi International', city: 'Sochi', country: 'Russia' },
  { code: 'VVO', name: 'Vladivostok Intl', city: 'Vladivostok', country: 'Russia' },
  { code: 'IKT', name: 'Irkutsk Intl', city: 'Irkutsk', country: 'Russia' },
  { code: 'UFA', name: 'Ufa Intl', city: 'Ufa', country: 'Russia' },

  // Ukraine
  { code: 'KBP', name: 'Kyiv Boryspil Intl', city: 'Kyiv', country: 'Ukraine' },
  { code: 'IEV', name: 'Kyiv Zhulyany Intl', city: 'Kyiv', country: 'Ukraine' },
  { code: 'ODS', name: 'Odesa Intl', city: 'Odesa', country: 'Ukraine' },
  { code: 'LWO', name: 'Lviv Danylo Halytskyi Intl', city: 'Lviv', country: 'Ukraine' },
  { code: 'HRK', name: 'Kharkiv Intl', city: 'Kharkiv', country: 'Ukraine' },

  // Belarus
  { code: 'MSQ', name: 'Minsk National Airport', city: 'Minsk', country: 'Belarus' },

  // Kazakhstan
  { code: 'ALA', name: 'Almaty Intl', city: 'Almaty', country: 'Kazakhstan' },
  { code: 'NQZ', name: 'Astana Nursultan Nazarbayev Intl', city: 'Astana', country: 'Kazakhstan' },
  { code: 'SCO', name: 'Aktau Airport', city: 'Aktau', country: 'Kazakhstan' },

  // Uzbekistan
  { code: 'TAS', name: 'Tashkent Intl', city: 'Tashkent', country: 'Uzbekistan' },
  { code: 'SKD', name: 'Samarkand Intl', city: 'Samarkand', country: 'Uzbekistan' },
  { code: 'BHK', name: 'Bukhara Intl', city: 'Bukhara', country: 'Uzbekistan' },

  // Azerbaijan
  { code: 'GYD', name: 'Baku Heydar Aliyev Intl', city: 'Baku', country: 'Azerbaijan' },

  // Georgia
  { code: 'TBS', name: 'Tbilisi Intl', city: 'Tbilisi', country: 'Georgia' },
  { code: 'BUS', name: 'Batumi Intl', city: 'Batumi', country: 'Georgia' },
  { code: 'KUT', name: 'Kutaisi Intl', city: 'Kutaisi', country: 'Georgia' },

  // Armenia
  { code: 'EVN', name: 'Yerevan Zvartnots Intl', city: 'Yerevan', country: 'Armenia' },

  // Serbia
  { code: 'BEG', name: 'Belgrade Nikola Tesla', city: 'Belgrade', country: 'Serbia' },
  { code: 'INI', name: 'Niš Constantine the Great', city: 'Niš', country: 'Serbia' },

  // Montenegro
  { code: 'TGD', name: 'Podgorica Airport', city: 'Podgorica', country: 'Montenegro' },
  { code: 'TIV', name: 'Tivat Airport', city: 'Tivat', country: 'Montenegro' },

  // North Macedonia
  { code: 'SKP', name: 'Skopje Intl', city: 'Skopje', country: 'North Macedonia' },
  { code: 'OHD', name: 'Ohrid St Paul the Apostle', city: 'Ohrid', country: 'North Macedonia' },

  // Albania
  { code: 'TIA', name: 'Tirana Mother Teresa Intl', city: 'Tirana', country: 'Albania' },

  // Kosovo
  { code: 'PRN', name: 'Pristina Intl', city: 'Pristina', country: 'Kosovo' },

  // Bosnia and Herzegovina
  { code: 'SJJ', name: 'Sarajevo Intl', city: 'Sarajevo', country: 'Bosnia and Herzegovina' },

  // Slovenia
  { code: 'LJU', name: 'Ljubljana Jože Pučnik', city: 'Ljubljana', country: 'Slovenia' },

  // Slovakia
  { code: 'BTS', name: 'Bratislava M. R. Štefánik', city: 'Bratislava', country: 'Slovakia' },
  { code: 'KSC', name: 'Košice Intl', city: 'Košice', country: 'Slovakia' },

  // Latvia
  { code: 'RIX', name: 'Riga Intl', city: 'Riga', country: 'Latvia' },

  // Lithuania
  { code: 'VNO', name: 'Vilnius Intl', city: 'Vilnius', country: 'Lithuania' },
  { code: 'KUN', name: 'Kaunas Intl', city: 'Kaunas', country: 'Lithuania' },

  // Estonia
  { code: 'TLL', name: 'Tallinn Lennart Meri', city: 'Tallinn', country: 'Estonia' },

  // Moldova
  { code: 'KIV', name: 'Chișinău Intl', city: 'Chișinău', country: 'Moldova' },

  // Cyprus
  { code: 'LCA', name: 'Larnaca Intl', city: 'Larnaca', country: 'Cyprus' },
  { code: 'PFO', name: 'Paphos Intl', city: 'Paphos', country: 'Cyprus' },
  { code: 'ECN', name: 'Ercan Intl', city: 'Nicosia', country: 'Cyprus' },

  // Malta
  { code: 'MLA', name: 'Malta Intl', city: 'Valletta', country: 'Malta' },

  // Iceland
  { code: 'KEF', name: 'Keflavik Intl', city: 'Reykjavik', country: 'Iceland' },
  { code: 'RKV', name: 'Reykjavik Domestic', city: 'Reykjavik', country: 'Iceland' },
  { code: 'AEY', name: 'Akureyri Airport', city: 'Akureyri', country: 'Iceland' },

  // Luxembourg
  { code: 'LUX', name: 'Luxembourg Findel', city: 'Luxembourg', country: 'Luxembourg' },

  // Monaco (uses Nice)
  { code: 'MCM', name: 'Monaco Heliport', city: 'Monaco', country: 'Monaco' },

  // Andorra (uses Barcelona/Toulouse)

  // San Marino (uses Rimini/Bologna)

  // Liechtenstein (uses Zurich)

  // Additional Middle East
  { code: 'IKA', name: 'Tehran Imam Khomeini Intl', city: 'Tehran', country: 'Iran' },
  { code: 'THR', name: 'Tehran Mehrabad Intl', city: 'Tehran', country: 'Iran' },
  { code: 'MHD', name: 'Mashhad Intl', city: 'Mashhad', country: 'Iran' },
  { code: 'SYZ', name: 'Shiraz Intl', city: 'Shiraz', country: 'Iran' },
  { code: 'IFN', name: 'Isfahan Intl', city: 'Isfahan', country: 'Iran' },
  { code: 'TBZ', name: 'Tabriz Intl', city: 'Tabriz', country: 'Iran' },
  { code: 'BGW', name: 'Baghdad Intl', city: 'Baghdad', country: 'Iraq' },
  { code: 'BSR', name: 'Basra Intl', city: 'Basra', country: 'Iraq' },
  { code: 'EBL', name: 'Erbil Intl', city: 'Erbil', country: 'Iraq' },
  { code: 'NJF', name: 'Najaf Intl', city: 'Najaf', country: 'Iraq' },
  { code: 'SYY', name: 'Stornoway Airport', city: 'Stornoway', country: 'United Kingdom' },
  { code: 'DAM', name: 'Damascus Intl', city: 'Damascus', country: 'Syria' },
  { code: 'ALP', name: 'Aleppo Intl', city: 'Aleppo', country: 'Syria' },
  { code: 'ADJ', name: 'Amman Civil Airport', city: 'Amman', country: 'Jordan' },
  { code: 'AQJ', name: 'Aqaba King Hussein Intl', city: 'Aqaba', country: 'Jordan' },
  { code: 'SDV', name: 'Tel Aviv Sde Dov', city: 'Tel Aviv', country: 'Israel' },
  { code: 'VDA', name: 'Ovda Intl', city: 'Eilat', country: 'Israel' },
  { code: 'ETM', name: 'Ramon Airport', city: 'Eilat', country: 'Israel' },
  { code: 'SLL', name: 'Salalah Intl', city: 'Salalah', country: 'Oman' },
  { code: 'SHO', name: 'Sohar Airport', city: 'Sohar', country: 'Oman' },
  { code: 'AHB', name: 'Abha Intl', city: 'Abha', country: 'Saudi Arabia' },
  { code: 'TUU', name: 'Tabuk Regional', city: 'Tabuk', country: 'Saudi Arabia' },
  { code: 'TIF', name: 'Taif Intl', city: 'Taif', country: 'Saudi Arabia' },
  { code: 'GIZ', name: 'Jazan Airport', city: 'Jazan', country: 'Saudi Arabia' },
  { code: 'ELQ', name: 'Qassim Intl', city: 'Buraidah', country: 'Saudi Arabia' },
  { code: 'HAS', name: 'Hail Intl', city: 'Hail', country: 'Saudi Arabia' },
  { code: 'YNB', name: 'Yanbu Intl', city: 'Yanbu', country: 'Saudi Arabia' },
  { code: 'ADE', name: 'Aden Intl', city: 'Aden', country: 'Yemen' },
  { code: 'SAH', name: 'Sanaa Intl', city: 'Sanaa', country: 'Yemen' },

  // Additional Africa
  { code: 'ALG', name: 'Algiers Houari Boumediene', city: 'Algiers', country: 'Algeria' },
  { code: 'ORN', name: 'Oran Es Sénia', city: 'Oran', country: 'Algeria' },
  { code: 'CZL', name: 'Constantine Mohamed Boudiaf', city: 'Constantine', country: 'Algeria' },
  { code: 'TIP', name: 'Tripoli Intl', city: 'Tripoli', country: 'Libya' },
  { code: 'BEN', name: 'Benghazi Benina Intl', city: 'Benghazi', country: 'Libya' },
  { code: 'KRT', name: 'Khartoum Intl', city: 'Khartoum', country: 'Sudan' },
  { code: 'PZU', name: 'Port Sudan Intl', city: 'Port Sudan', country: 'Sudan' },
  { code: 'JUB', name: 'Juba Intl', city: 'Juba', country: 'South Sudan' },
  { code: 'ASM', name: 'Asmara Intl', city: 'Asmara', country: 'Eritrea' },
  { code: 'JIB', name: 'Djibouti-Ambouli Intl', city: 'Djibouti', country: 'Djibouti' },
  { code: 'MGQ', name: 'Mogadishu Aden Adde Intl', city: 'Mogadishu', country: 'Somalia' },
  { code: 'EBB', name: 'Entebbe Intl', city: 'Entebbe', country: 'Uganda' },
  { code: 'KGL', name: 'Kigali Intl', city: 'Kigali', country: 'Rwanda' },
  { code: 'BJM', name: 'Bujumbura Intl', city: 'Bujumbura', country: 'Burundi' },
  { code: 'FIH', name: 'Kinshasa N\'djili Intl', city: 'Kinshasa', country: 'DR Congo' },
  { code: 'FBM', name: 'Lubumbashi Intl', city: 'Lubumbashi', country: 'DR Congo' },
  { code: 'BZV', name: 'Brazzaville Maya-Maya', city: 'Brazzaville', country: 'Congo' },
  { code: 'LBV', name: 'Libreville Leon M\'ba Intl', city: 'Libreville', country: 'Gabon' },
  { code: 'SSG', name: 'Malabo Intl', city: 'Malabo', country: 'Equatorial Guinea' },
  { code: 'DLA', name: 'Douala Intl', city: 'Douala', country: 'Cameroon' },
  { code: 'NSI', name: 'Yaoundé Nsimalen Intl', city: 'Yaoundé', country: 'Cameroon' },
  { code: 'NDJ', name: 'N\'Djamena Intl', city: 'N\'Djamena', country: 'Chad' },
  { code: 'OUA', name: 'Ouagadougou Intl', city: 'Ouagadougou', country: 'Burkina Faso' },
  { code: 'ABJ', name: 'Abidjan Félix Houphouët-Boigny', city: 'Abidjan', country: 'Ivory Coast' },
  { code: 'COO', name: 'Cotonou Cadjehoun', city: 'Cotonou', country: 'Benin' },
  { code: 'LFW', name: 'Lomé Gnassingbé Eyadéma', city: 'Lomé', country: 'Togo' },
  { code: 'NIM', name: 'Niamey Diori Hamani', city: 'Niamey', country: 'Niger' },
  { code: 'BKO', name: 'Bamako Modibo Keïta', city: 'Bamako', country: 'Mali' },
  { code: 'CKY', name: 'Conakry Intl', city: 'Conakry', country: 'Guinea' },
  { code: 'DKR', name: 'Dakar Blaise Diagne Intl', city: 'Dakar', country: 'Senegal' },
  { code: 'BJL', name: 'Banjul Intl', city: 'Banjul', country: 'Gambia' },
  { code: 'FNA', name: 'Freetown Lungi Intl', city: 'Freetown', country: 'Sierra Leone' },
  { code: 'ROB', name: 'Monrovia Roberts Intl', city: 'Monrovia', country: 'Liberia' },
  { code: 'NKC', name: 'Nouakchott Oumtounsy Intl', city: 'Nouakchott', country: 'Mauritania' },
  { code: 'TNG', name: 'Tangier Ibn Battouta', city: 'Tangier', country: 'Morocco' },
  { code: 'OZZ', name: 'Ouarzazate Airport', city: 'Ouarzazate', country: 'Morocco' },
  { code: 'NDR', name: 'Nador Intl', city: 'Nador', country: 'Morocco' },
  { code: 'SEZ', name: 'Seychelles Intl', city: 'Mahé', country: 'Seychelles' },
  { code: 'MRU', name: 'Mauritius Sir Seewoosagur Ramgoolam', city: 'Mauritius', country: 'Mauritius' },
  { code: 'RUN', name: 'Roland Garros Intl', city: 'Saint-Denis', country: 'Réunion' },
  { code: 'TNR', name: 'Antananarivo Ivato Intl', city: 'Antananarivo', country: 'Madagascar' },
  { code: 'NOS', name: 'Nosy Be Fascene', city: 'Nosy Be', country: 'Madagascar' },
  { code: 'HAH', name: 'Prince Said Ibrahim Intl', city: 'Moroni', country: 'Comoros' },
  { code: 'MPM', name: 'Maputo Intl', city: 'Maputo', country: 'Mozambique' },
  { code: 'BEW', name: 'Beira Airport', city: 'Beira', country: 'Mozambique' },
  { code: 'HRE', name: 'Harare Intl', city: 'Harare', country: 'Zimbabwe' },
  { code: 'VFA', name: 'Victoria Falls Intl', city: 'Victoria Falls', country: 'Zimbabwe' },
  { code: 'LLW', name: 'Lilongwe Intl', city: 'Lilongwe', country: 'Malawi' },
  { code: 'LUN', name: 'Lusaka Kenneth Kaunda', city: 'Lusaka', country: 'Zambia' },
  { code: 'LVI', name: 'Livingstone Harry Mwanga Nkumbula', city: 'Livingstone', country: 'Zambia' },
  { code: 'GBE', name: 'Gaborone Sir Seretse Khama', city: 'Gaborone', country: 'Botswana' },
  { code: 'MUB', name: 'Maun Airport', city: 'Maun', country: 'Botswana' },
  { code: 'WDH', name: 'Windhoek Hosea Kutako Intl', city: 'Windhoek', country: 'Namibia' },
  { code: 'SWP', name: 'Swakopmund Airport', city: 'Swakopmund', country: 'Namibia' },
  { code: 'LAD', name: 'Luanda Quatro de Fevereiro', city: 'Luanda', country: 'Angola' },
  { code: 'PLZ', name: 'Port Elizabeth Intl', city: 'Port Elizabeth', country: 'South Africa' },
  { code: 'GRJ', name: 'George Airport', city: 'George', country: 'South Africa' },
  { code: 'ELS', name: 'East London Airport', city: 'East London', country: 'South Africa' },
  { code: 'BFN', name: 'Bloemfontein Bram Fischer', city: 'Bloemfontein', country: 'South Africa' },

  // Additional Asia
  { code: 'ULN', name: 'Ulaanbaatar Chinggis Khaan', city: 'Ulaanbaatar', country: 'Mongolia' },
  { code: 'PYY', name: 'Pai Airport', city: 'Pai', country: 'Thailand' },
  { code: 'KBV', name: 'Krabi Airport', city: 'Krabi', country: 'Thailand' },
  { code: 'UTH', name: 'Udon Thani Intl', city: 'Udon Thani', country: 'Thailand' },
  { code: 'UTP', name: 'U-Tapao Intl', city: 'Pattaya', country: 'Thailand' },
  { code: 'VTE', name: 'Vientiane Wattay Intl', city: 'Vientiane', country: 'Laos' },
  { code: 'LPQ', name: 'Luang Prabang Intl', city: 'Luang Prabang', country: 'Laos' },
  { code: 'PNH', name: 'Phnom Penh Intl', city: 'Phnom Penh', country: 'Cambodia' },
  { code: 'REP', name: 'Siem Reap Intl', city: 'Siem Reap', country: 'Cambodia' },
  { code: 'RGN', name: 'Yangon Intl', city: 'Yangon', country: 'Myanmar' },
  { code: 'MDL', name: 'Mandalay Intl', city: 'Mandalay', country: 'Myanmar' },
  { code: 'NYT', name: 'Naypyidaw Intl', city: 'Naypyidaw', country: 'Myanmar' },
  { code: 'BWN', name: 'Brunei Intl', city: 'Bandar Seri Begawan', country: 'Brunei' },
  { code: 'DIL', name: 'Dili Presidente Nicolau Lobato', city: 'Dili', country: 'Timor-Leste' },
  { code: 'TSN', name: 'Tianjin Binhai Intl', city: 'Tianjin', country: 'China' },
  { code: 'DLC', name: 'Dalian Zhoushuizi Intl', city: 'Dalian', country: 'China' },
  { code: 'TAO', name: 'Qingdao Jiaodong Intl', city: 'Qingdao', country: 'China' },
  { code: 'CKG', name: 'Chongqing Jiangbei Intl', city: 'Chongqing', country: 'China' },
  { code: 'XMN', name: 'Xiamen Gaoqi Intl', city: 'Xiamen', country: 'China' },
  { code: 'FOC', name: 'Fuzhou Changle Intl', city: 'Fuzhou', country: 'China' },
  { code: 'NNG', name: 'Nanning Wuxu Intl', city: 'Nanning', country: 'China' },
  { code: 'HAK', name: 'Haikou Meilan Intl', city: 'Haikou', country: 'China' },
  { code: 'SYX', name: 'Sanya Phoenix Intl', city: 'Sanya', country: 'China' },
  { code: 'CGO', name: 'Zhengzhou Xinzheng Intl', city: 'Zhengzhou', country: 'China' },
  { code: 'SJW', name: 'Shijiazhuang Zhengding Intl', city: 'Shijiazhuang', country: 'China' },
  { code: 'URC', name: 'Ürümqi Diwopu Intl', city: 'Ürümqi', country: 'China' },
  { code: 'LHW', name: 'Lanzhou Zhongchuan Intl', city: 'Lanzhou', country: 'China' },
  { code: 'TYN', name: 'Taiyuan Wusu Intl', city: 'Taiyuan', country: 'China' },
  { code: 'HET', name: 'Hohhot Baita Intl', city: 'Hohhot', country: 'China' },
  { code: 'SHE', name: 'Shenyang Taoxian Intl', city: 'Shenyang', country: 'China' },
  { code: 'HRB', name: 'Harbin Taiping Intl', city: 'Harbin', country: 'China' },
  { code: 'CGQ', name: 'Changchun Longjia Intl', city: 'Changchun', country: 'China' },
  { code: 'KWL', name: 'Guilin Liangjiang Intl', city: 'Guilin', country: 'China' },
  { code: 'LXA', name: 'Lhasa Gonggar Airport', city: 'Lhasa', country: 'China' },
  { code: 'KWE', name: 'Guiyang Longdongbao Intl', city: 'Guiyang', country: 'China' },

  // Additional India
  { code: 'IXE', name: 'Mangalore Intl', city: 'Mangalore', country: 'India' },
  { code: 'TRV', name: 'Trivandrum Intl', city: 'Thiruvananthapuram', country: 'India' },
  { code: 'CCJ', name: 'Kozhikode Intl', city: 'Kozhikode', country: 'India' },
  { code: 'IXC', name: 'Chandigarh Intl', city: 'Chandigarh', country: 'India' },
  { code: 'LKO', name: 'Lucknow Chaudhary Charan Singh', city: 'Lucknow', country: 'India' },
  { code: 'VNS', name: 'Varanasi Lal Bahadur Shastri', city: 'Varanasi', country: 'India' },
  { code: 'PAT', name: 'Patna Jay Prakash Narayan', city: 'Patna', country: 'India' },
  { code: 'GAU', name: 'Guwahati Lokpriya Gopinath Bordoloi', city: 'Guwahati', country: 'India' },
  { code: 'BBI', name: 'Bhubaneswar Biju Patnaik', city: 'Bhubaneswar', country: 'India' },
  { code: 'VTZ', name: 'Visakhapatnam Airport', city: 'Visakhapatnam', country: 'India' },
  { code: 'NAG', name: 'Nagpur Dr. Babasaheb Ambedkar', city: 'Nagpur', country: 'India' },
  { code: 'IDR', name: 'Indore Devi Ahilyabai Holkar', city: 'Indore', country: 'India' },
  { code: 'BHO', name: 'Bhopal Raja Bhoj', city: 'Bhopal', country: 'India' },
  { code: 'SXR', name: 'Srinagar Intl', city: 'Srinagar', country: 'India' },
  { code: 'IXL', name: 'Leh Kushok Bakula Rimpochee', city: 'Leh', country: 'India' },
  { code: 'ATQ', name: 'Amritsar Sri Guru Ram Dass Jee', city: 'Amritsar', country: 'India' },
  { code: 'RAJ', name: 'Rajkot Airport', city: 'Rajkot', country: 'India' },
  { code: 'UDR', name: 'Udaipur Maharana Pratap', city: 'Udaipur', country: 'India' },
  { code: 'JDH', name: 'Jodhpur Airport', city: 'Jodhpur', country: 'India' },
  { code: 'DEP', name: 'Daporijo Airport', city: 'Daporijo', country: 'India' },
  { code: 'IXR', name: 'Ranchi Birsa Munda', city: 'Ranchi', country: 'India' },
  { code: 'RPR', name: 'Raipur Swami Vivekananda', city: 'Raipur', country: 'India' },
  { code: 'CJB', name: 'Coimbatore Intl', city: 'Coimbatore', country: 'India' },
  { code: 'TRZ', name: 'Tiruchirappalli Intl', city: 'Tiruchirappalli', country: 'India' },
  { code: 'IXM', name: 'Madurai Airport', city: 'Madurai', country: 'India' },

  // Additional Pakistan
  { code: 'PEW', name: 'Peshawar Bacha Khan Intl', city: 'Peshawar', country: 'Pakistan' },
  { code: 'UET', name: 'Quetta Intl', city: 'Quetta', country: 'Pakistan' },
  { code: 'MUX', name: 'Multan Intl', city: 'Multan', country: 'Pakistan' },
  { code: 'SKT', name: 'Sialkot Intl', city: 'Sialkot', country: 'Pakistan' },
  { code: 'FSD', name: 'Faisalabad Intl', city: 'Faisalabad', country: 'Pakistan' },
  { code: 'GWD', name: 'Gwadar Intl', city: 'Gwadar', country: 'Pakistan' },

  // Additional Bangladesh
  { code: 'CGP', name: 'Chittagong Shah Amanat Intl', city: 'Chittagong', country: 'Bangladesh' },
  { code: 'ZYL', name: 'Sylhet Osmani Intl', city: 'Sylhet', country: 'Bangladesh' },
  { code: 'CXB', name: 'Cox\'s Bazar Airport', city: 'Cox\'s Bazar', country: 'Bangladesh' },

  // Additional Sri Lanka
  { code: 'HRI', name: 'Mattala Rajapaksa Intl', city: 'Hambantota', country: 'Sri Lanka' },
  { code: 'JAF', name: 'Jaffna Intl', city: 'Jaffna', country: 'Sri Lanka' },

  // Bhutan
  { code: 'PBH', name: 'Paro Intl', city: 'Paro', country: 'Bhutan' },

  // Afghanistan
  { code: 'KBL', name: 'Kabul Intl', city: 'Kabul', country: 'Afghanistan' },
  { code: 'KDH', name: 'Kandahar Intl', city: 'Kandahar', country: 'Afghanistan' },
  { code: 'MZR', name: 'Mazar-i-Sharif Intl', city: 'Mazar-i-Sharif', country: 'Afghanistan' },
  { code: 'HEA', name: 'Herat Intl', city: 'Herat', country: 'Afghanistan' },

  // Tajikistan
  { code: 'DYU', name: 'Dushanbe Intl', city: 'Dushanbe', country: 'Tajikistan' },

  // Kyrgyzstan
  { code: 'FRU', name: 'Bishkek Manas Intl', city: 'Bishkek', country: 'Kyrgyzstan' },
  { code: 'OSS', name: 'Osh Airport', city: 'Osh', country: 'Kyrgyzstan' },

  // Turkmenistan
  { code: 'ASB', name: 'Ashgabat Intl', city: 'Ashgabat', country: 'Turkmenistan' },

  // Additional Pacific Islands
  { code: 'APW', name: 'Apia Faleolo Intl', city: 'Apia', country: 'Samoa' },
  { code: 'TBU', name: 'Tongatapu Fuaʻamotu Intl', city: 'Nukuʻalofa', country: 'Tonga' },
  { code: 'SUV', name: 'Suva Nausori Intl', city: 'Suva', country: 'Fiji' },
  { code: 'VLI', name: 'Port Vila Bauerfield Intl', city: 'Port Vila', country: 'Vanuatu' },
  { code: 'NOU', name: 'Nouméa La Tontouta Intl', city: 'Nouméa', country: 'New Caledonia' },
  { code: 'HIR', name: 'Honiara Intl', city: 'Honiara', country: 'Solomon Islands' },
  { code: 'POM', name: 'Port Moresby Jacksons Intl', city: 'Port Moresby', country: 'Papua New Guinea' },
  { code: 'TRW', name: 'Tarawa Bonriki Intl', city: 'Tarawa', country: 'Kiribati' },
  { code: 'FUN', name: 'Funafuti Intl', city: 'Funafuti', country: 'Tuvalu' },
  { code: 'INU', name: 'Nauru Intl', city: 'Nauru', country: 'Nauru' },
  { code: 'MAJ', name: 'Majuro Marshall Islands Intl', city: 'Majuro', country: 'Marshall Islands' },
  { code: 'KSA', name: 'Kosrae Intl', city: 'Kosrae', country: 'Micronesia' },
  { code: 'TKK', name: 'Chuuk Intl', city: 'Chuuk', country: 'Micronesia' },
  { code: 'PNI', name: 'Pohnpei Intl', city: 'Pohnpei', country: 'Micronesia' },
  { code: 'YAP', name: 'Yap Intl', city: 'Yap', country: 'Micronesia' },
  { code: 'ROR', name: 'Koror Roman Tmetuchl Intl', city: 'Koror', country: 'Palau' },
  { code: 'GUM', name: 'Guam Antonio B. Won Pat Intl', city: 'Guam', country: 'Guam' },
  { code: 'SPN', name: 'Saipan Intl', city: 'Saipan', country: 'Northern Mariana Islands' },

  // Additional Australia
  { code: 'CBR', name: 'Canberra Airport', city: 'Canberra', country: 'Australia' },
  { code: 'TSV', name: 'Townsville Airport', city: 'Townsville', country: 'Australia' },
  { code: 'NTL', name: 'Newcastle Williamtown', city: 'Newcastle', country: 'Australia' },
  { code: 'ASP', name: 'Alice Springs Airport', city: 'Alice Springs', country: 'Australia' },
  { code: 'LST', name: 'Launceston Airport', city: 'Launceston', country: 'Australia' },
  { code: 'MCY', name: 'Sunshine Coast Airport', city: 'Maroochydore', country: 'Australia' },
  { code: 'BME', name: 'Broome Intl', city: 'Broome', country: 'Australia' },
  { code: 'HTI', name: 'Hamilton Island Airport', city: 'Hamilton Island', country: 'Australia' },
  { code: 'PPP', name: 'Proserpine Whitsunday Coast', city: 'Proserpine', country: 'Australia' },

  // Additional New Zealand
  { code: 'DUD', name: 'Dunedin Airport', city: 'Dunedin', country: 'New Zealand' },
  { code: 'PMR', name: 'Palmerston North Airport', city: 'Palmerston North', country: 'New Zealand' },
  { code: 'HLZ', name: 'Hamilton Airport', city: 'Hamilton', country: 'New Zealand' },
  { code: 'NPL', name: 'New Plymouth Airport', city: 'New Plymouth', country: 'New Zealand' },
  { code: 'ROT', name: 'Rotorua Airport', city: 'Rotorua', country: 'New Zealand' },
  { code: 'TRG', name: 'Tauranga Airport', city: 'Tauranga', country: 'New Zealand' },
  { code: 'NSN', name: 'Nelson Airport', city: 'Nelson', country: 'New Zealand' },
  { code: 'BHE', name: 'Blenheim Airport', city: 'Blenheim', country: 'New Zealand' },
  { code: 'IVC', name: 'Invercargill Airport', city: 'Invercargill', country: 'New Zealand' },

  // Additional Caribbean
  { code: 'SXM', name: 'Sint Maarten Princess Juliana', city: 'Philipsburg', country: 'Sint Maarten' },
  { code: 'POS', name: 'Port of Spain Piarco Intl', city: 'Port of Spain', country: 'Trinidad and Tobago' },
  { code: 'TAB', name: 'Tobago A.N.R. Robinson Intl', city: 'Scarborough', country: 'Trinidad and Tobago' },
  { code: 'GND', name: 'Grenada Maurice Bishop Intl', city: 'St. George\'s', country: 'Grenada' },
  { code: 'SVD', name: 'St Vincent E.T. Joshua', city: 'Kingstown', country: 'Saint Vincent' },
  { code: 'SLU', name: 'Saint Lucia George F.L. Charles', city: 'Castries', country: 'Saint Lucia' },
  { code: 'UVF', name: 'Saint Lucia Hewanorra Intl', city: 'Vieux Fort', country: 'Saint Lucia' },
  { code: 'DOM', name: 'Dominica Douglas-Charles', city: 'Roseau', country: 'Dominica' },
  { code: 'ANU', name: 'Antigua V.C. Bird Intl', city: 'St. John\'s', country: 'Antigua and Barbuda' },
  { code: 'SKB', name: 'St Kitts Robert L. Bradshaw', city: 'Basseterre', country: 'Saint Kitts and Nevis' },
  { code: 'EIS', name: 'Tortola Terrance B. Lettsome', city: 'Tortola', country: 'British Virgin Islands' },
  { code: 'STT', name: 'St Thomas Cyril E. King', city: 'Charlotte Amalie', country: 'US Virgin Islands' },
  { code: 'STX', name: 'St Croix Henry E. Rohlsen', city: 'Christiansted', country: 'US Virgin Islands' },
  { code: 'BON', name: 'Bonaire Flamingo Intl', city: 'Kralendijk', country: 'Bonaire' },
  { code: 'GCM', name: 'Grand Cayman Owen Roberts Intl', city: 'George Town', country: 'Cayman Islands' },
  { code: 'HOG', name: 'Holguín Frank País', city: 'Holguín', country: 'Cuba' },
  { code: 'VRA', name: 'Varadero Juan Gualberto Gómez', city: 'Varadero', country: 'Cuba' },
  { code: 'SCU', name: 'Santiago de Cuba Antonio Maceo', city: 'Santiago de Cuba', country: 'Cuba' },

  // Additional Central America
  { code: 'TGU', name: 'Tegucigalpa Toncontín Intl', city: 'Tegucigalpa', country: 'Honduras' },
  { code: 'SAP', name: 'San Pedro Sula Ramón Villeda Morales', city: 'San Pedro Sula', country: 'Honduras' },
  { code: 'RTB', name: 'Roatán Juan Manuel Gálvez', city: 'Roatán', country: 'Honduras' },
  { code: 'MGA', name: 'Managua Augusto C. Sandino', city: 'Managua', country: 'Nicaragua' },
  { code: 'BZE', name: 'Belize City Philip S.W. Goldson', city: 'Belize City', country: 'Belize' },

  // Additional South America
  { code: 'GEO', name: 'Georgetown Cheddi Jagan Intl', city: 'Georgetown', country: 'Guyana' },
  { code: 'PBM', name: 'Paramaribo Johan Adolf Pengel', city: 'Paramaribo', country: 'Suriname' },
  { code: 'CAY', name: 'Cayenne Félix Eboué', city: 'Cayenne', country: 'French Guiana' },
  { code: 'ASU', name: 'Asunción Silvio Pettirossi', city: 'Asunción', country: 'Paraguay' },
  { code: 'MVD', name: 'Montevideo Carrasco Intl', city: 'Montevideo', country: 'Uruguay' },
  { code: 'PUQ', name: 'Punta Arenas Carlos Ibáñez', city: 'Punta Arenas', country: 'Chile' },
  { code: 'CCP', name: 'Concepción Carriel Sur Intl', city: 'Concepción', country: 'Chile' },
  { code: 'IQQ', name: 'Iquique Diego Aracena Intl', city: 'Iquique', country: 'Chile' },
  { code: 'ANF', name: 'Antofagasta Cerro Moreno', city: 'Antofagasta', country: 'Chile' },
  { code: 'PMC', name: 'Puerto Montt El Tepual', city: 'Puerto Montt', country: 'Chile' },
  { code: 'IPC', name: 'Easter Island Mataveri Intl', city: 'Hanga Roa', country: 'Chile' },
  { code: 'CBB', name: 'Cochabamba Jorge Wilstermann', city: 'Cochabamba', country: 'Bolivia' },
  { code: 'LPB', name: 'La Paz El Alto Intl', city: 'La Paz', country: 'Bolivia' },
  { code: 'VVI', name: 'Santa Cruz Viru Viru Intl', city: 'Santa Cruz', country: 'Bolivia' },
  { code: 'AQP', name: 'Arequipa Rodríguez Ballón', city: 'Arequipa', country: 'Peru' },
  { code: 'PIU', name: 'Piura Cap. FAP Guillermo Concha', city: 'Piura', country: 'Peru' },
  { code: 'TRU', name: 'Trujillo Cap. FAP Carlos Martínez de Pinillos', city: 'Trujillo', country: 'Peru' },
  { code: 'IQT', name: 'Iquitos Coronel FAP Francisco Secada Vignetta', city: 'Iquitos', country: 'Peru' },
  { code: 'COR', name: 'Córdoba Ingeniero Ambrosio Taravella', city: 'Córdoba', country: 'Argentina' },
  { code: 'MDZ', name: 'Mendoza El Plumerillo', city: 'Mendoza', country: 'Argentina' },
  { code: 'SLA', name: 'Salta Martín Miguel de Güemes', city: 'Salta', country: 'Argentina' },
  { code: 'IGR', name: 'Iguazú Cataratas del Iguazú', city: 'Puerto Iguazú', country: 'Argentina' },
  { code: 'BRC', name: 'Bariloche Teniente Luis Candelaria', city: 'Bariloche', country: 'Argentina' },
  { code: 'USH', name: 'Ushuaia Malvinas Argentinas', city: 'Ushuaia', country: 'Argentina' },
  { code: 'FLN', name: 'Florianópolis Hercílio Luz', city: 'Florianópolis', country: 'Brazil' },
  { code: 'POA', name: 'Porto Alegre Salgado Filho', city: 'Porto Alegre', country: 'Brazil' },
  { code: 'CWB', name: 'Curitiba Afonso Pena', city: 'Curitiba', country: 'Brazil' },
  { code: 'VIX', name: 'Vitória Eurico de Aguiar Salles', city: 'Vitória', country: 'Brazil' },
  { code: 'NAT', name: 'Natal Augusto Severo', city: 'Natal', country: 'Brazil' },
  { code: 'MCZ', name: 'Maceió Zumbi dos Palmares', city: 'Maceió', country: 'Brazil' },
  { code: 'AJU', name: 'Aracaju Santa Maria', city: 'Aracaju', country: 'Brazil' },
  { code: 'SLZ', name: 'São Luís Marechal Cunha Machado', city: 'São Luís', country: 'Brazil' },
  { code: 'THE', name: 'Teresina Senador Petrônio Portella', city: 'Teresina', country: 'Brazil' },
  { code: 'BEL', name: 'Belém Val de Cans', city: 'Belém', country: 'Brazil' },
  { code: 'MAO', name: 'Manaus Eduardo Gomes', city: 'Manaus', country: 'Brazil' },
  { code: 'GYN', name: 'Goiânia Santa Genoveva', city: 'Goiânia', country: 'Brazil' },
  { code: 'CGR', name: 'Campo Grande Intl', city: 'Campo Grande', country: 'Brazil' },
  { code: 'CGB', name: 'Cuiabá Marechal Rondon', city: 'Cuiabá', country: 'Brazil' },
  { code: 'PVH', name: 'Porto Velho Governador Jorge Teixeira', city: 'Porto Velho', country: 'Brazil' },
  { code: 'RBR', name: 'Rio Branco Plácido de Castro', city: 'Rio Branco', country: 'Brazil' },
  { code: 'BPS', name: 'Porto Seguro Intl', city: 'Porto Seguro', country: 'Brazil' },
  { code: 'IOS', name: 'Ilhéus Jorge Amado', city: 'Ilhéus', country: 'Brazil' },
  { code: 'PNZ', name: 'Petrolina Senador Nilo Coelho', city: 'Petrolina', country: 'Brazil' },
  { code: 'JPA', name: 'João Pessoa Presidente Castro Pinto', city: 'João Pessoa', country: 'Brazil' },

  // Additional Mexico
  { code: 'SLP', name: 'San Luis Potosí Ponciano Arriaga', city: 'San Luis Potosí', country: 'Mexico' },
  { code: 'AGU', name: 'Aguascalientes Jesús Terán Peredo', city: 'Aguascalientes', country: 'Mexico' },
  { code: 'ZIH', name: 'Ixtapa-Zihuatanejo Intl', city: 'Zihuatanejo', country: 'Mexico' },
  { code: 'ACA', name: 'Acapulco Juan N. Álvarez', city: 'Acapulco', country: 'Mexico' },
  { code: 'HUX', name: 'Huatulco Bahías de Huatulco', city: 'Huatulco', country: 'Mexico' },
  { code: 'OAX', name: 'Oaxaca Xoxocotlán', city: 'Oaxaca', country: 'Mexico' },
  { code: 'CME', name: 'Ciudad del Carmen Intl', city: 'Ciudad del Carmen', country: 'Mexico' },
  { code: 'VSA', name: 'Villahermosa Carlos Rovirosa Pérez', city: 'Villahermosa', country: 'Mexico' },
  { code: 'TAP', name: 'Tapachula Intl', city: 'Tapachula', country: 'Mexico' },
  { code: 'TGZ', name: 'Tuxtla Gutiérrez Ángel Albino Corzo', city: 'Tuxtla Gutiérrez', country: 'Mexico' },
  { code: 'CJS', name: 'Ciudad Juárez Abraham González', city: 'Ciudad Juárez', country: 'Mexico' },
  { code: 'MXL', name: 'Mexicali General Rodolfo Sánchez Taboada', city: 'Mexicali', country: 'Mexico' },
  { code: 'CUU', name: 'Chihuahua Roberto Fierro Villalobos', city: 'Chihuahua', country: 'Mexico' },
  { code: 'CUL', name: 'Culiacán Bachigualato Federal', city: 'Culiacán', country: 'Mexico' },
  { code: 'MZT', name: 'Mazatlán General Rafael Buelna', city: 'Mazatlán', country: 'Mexico' },
  { code: 'ZLO', name: 'Manzanillo Playa de Oro', city: 'Manzanillo', country: 'Mexico' },
  { code: 'TRC', name: 'Torreón Francisco Sarabia', city: 'Torreón', country: 'Mexico' },
  { code: 'LAP', name: 'La Paz Manuel Márquez de León', city: 'La Paz', country: 'Mexico' },
  { code: 'BJX', name: 'León Del Bajío', city: 'León', country: 'Mexico' },
  { code: 'QRO', name: 'Querétaro Intl', city: 'Querétaro', country: 'Mexico' },
  { code: 'MLM', name: 'Morelia General Francisco J. Mújica', city: 'Morelia', country: 'Mexico' },
  { code: 'VER', name: 'Veracruz General Heriberto Jara', city: 'Veracruz', country: 'Mexico' },
  { code: 'PBC', name: 'Puebla Hermanos Serdán', city: 'Puebla', country: 'Mexico' },
  { code: 'CZM', name: 'Cozumel Intl', city: 'Cozumel', country: 'Mexico' },

  // Additional US
  { code: 'ABQ', name: 'Albuquerque Intl Sunport', city: 'Albuquerque', country: 'United States' },
  { code: 'OMA', name: 'Omaha Eppley Airfield', city: 'Omaha', country: 'United States' },
  { code: 'OKC', name: 'Oklahoma City Will Rogers World', city: 'Oklahoma City', country: 'United States' },
  { code: 'TUL', name: 'Tulsa Intl', city: 'Tulsa', country: 'United States' },
  { code: 'SAT', name: 'San Antonio Intl', city: 'San Antonio', country: 'United States' },
  { code: 'ELP', name: 'El Paso Intl', city: 'El Paso', country: 'United States' },
  { code: 'TUS', name: 'Tucson Intl', city: 'Tucson', country: 'United States' },
  { code: 'SMF', name: 'Sacramento Intl', city: 'Sacramento', country: 'United States' },
  { code: 'BNA', name: 'Nashville Intl', city: 'Nashville', country: 'United States' },
  { code: 'MEM', name: 'Memphis Intl', city: 'Memphis', country: 'United States' },
  { code: 'SDF', name: 'Louisville Muhammad Ali Intl', city: 'Louisville', country: 'United States' },
  { code: 'CVG', name: 'Cincinnati/Northern Kentucky Intl', city: 'Cincinnati', country: 'United States' },
  { code: 'CMH', name: 'Columbus John Glenn Intl', city: 'Columbus', country: 'United States' },
  { code: 'CLE', name: 'Cleveland Hopkins Intl', city: 'Cleveland', country: 'United States' },
  { code: 'INP', name: 'Indianapolis Intl', city: 'Indianapolis', country: 'United States' },
  { code: 'MKE', name: 'Milwaukee Mitchell Intl', city: 'Milwaukee', country: 'United States' },
  { code: 'BUF', name: 'Buffalo Niagara Intl', city: 'Buffalo', country: 'United States' },
  { code: 'ROC', name: 'Rochester Greater Rochester Intl', city: 'Rochester', country: 'United States' },
  { code: 'SYR', name: 'Syracuse Hancock Intl', city: 'Syracuse', country: 'United States' },
  { code: 'ALB', name: 'Albany Intl', city: 'Albany', country: 'United States' },
  { code: 'PVD', name: 'Providence T.F. Green', city: 'Providence', country: 'United States' },
  { code: 'BDL', name: 'Hartford Bradley Intl', city: 'Hartford', country: 'United States' },
  { code: 'PWM', name: 'Portland Intl Jetport', city: 'Portland', country: 'United States' },
  { code: 'MHT', name: 'Manchester-Boston Regional', city: 'Manchester', country: 'United States' },
  { code: 'RIC', name: 'Richmond Intl', city: 'Richmond', country: 'United States' },
  { code: 'ORF', name: 'Norfolk Intl', city: 'Norfolk', country: 'United States' },
  { code: 'JAX', name: 'Jacksonville Intl', city: 'Jacksonville', country: 'United States' },
  { code: 'RSW', name: 'Fort Myers Southwest Florida Intl', city: 'Fort Myers', country: 'United States' },
  { code: 'PNS', name: 'Pensacola Intl', city: 'Pensacola', country: 'United States' },
  { code: 'MOB', name: 'Mobile Regional', city: 'Mobile', country: 'United States' },
  { code: 'BHM', name: 'Birmingham-Shuttlesworth Intl', city: 'Birmingham', country: 'United States' },
  { code: 'HSV', name: 'Huntsville Intl', city: 'Huntsville', country: 'United States' },
  { code: 'SAV', name: 'Savannah/Hilton Head Intl', city: 'Savannah', country: 'United States' },
  { code: 'CHS', name: 'Charleston Intl', city: 'Charleston', country: 'United States' },
  { code: 'MYR', name: 'Myrtle Beach Intl', city: 'Myrtle Beach', country: 'United States' },
  { code: 'GSO', name: 'Greensboro Piedmont Triad', city: 'Greensboro', country: 'United States' },
  { code: 'RNO', name: 'Reno-Tahoe Intl', city: 'Reno', country: 'United States' },
  { code: 'BOI', name: 'Boise Airport', city: 'Boise', country: 'United States' },
  { code: 'GEG', name: 'Spokane Intl', city: 'Spokane', country: 'United States' },
  { code: 'ANC', name: 'Anchorage Ted Stevens', city: 'Anchorage', country: 'United States' },
  { code: 'FAI', name: 'Fairbanks Intl', city: 'Fairbanks', country: 'United States' },
  { code: 'JNU', name: 'Juneau Intl', city: 'Juneau', country: 'United States' },
  { code: 'OGG', name: 'Kahului Airport', city: 'Maui', country: 'United States' },
  { code: 'KOA', name: 'Kona Intl at Keahole', city: 'Kona', country: 'United States' },
  { code: 'LIH', name: 'Lihue Airport', city: 'Kauai', country: 'United States' },
  { code: 'ITO', name: 'Hilo Intl', city: 'Hilo', country: 'United States' },

  // Additional Canada
  { code: 'YQB', name: 'Quebec City Jean Lesage', city: 'Quebec City', country: 'Canada' },
  { code: 'YXU', name: 'London Intl', city: 'London', country: 'Canada' },
  { code: 'YKA', name: 'Kamloops Airport', city: 'Kamloops', country: 'Canada' },
  { code: 'YLW', name: 'Kelowna Intl', city: 'Kelowna', country: 'Canada' },
  { code: 'YQR', name: 'Regina Intl', city: 'Regina', country: 'Canada' },
  { code: 'YXE', name: 'Saskatoon John G. Diefenbaker', city: 'Saskatoon', country: 'Canada' },
  { code: 'YQT', name: 'Thunder Bay Intl', city: 'Thunder Bay', country: 'Canada' },
  { code: 'YYT', name: 'St. John\'s Intl', city: 'St. John\'s', country: 'Canada' },
  { code: 'YYJ', name: 'Victoria Intl', city: 'Victoria', country: 'Canada' },
  { code: 'YZF', name: 'Yellowknife Airport', city: 'Yellowknife', country: 'Canada' },
  { code: 'YXY', name: 'Whitehorse Erik Nielsen', city: 'Whitehorse', country: 'Canada' },
  { code: 'YFB', name: 'Iqaluit Airport', city: 'Iqaluit', country: 'Canada' }
];

// Airport groups for "Any" options
export const airportGroups = [
  { 
    code: 'LON', 
    name: 'Any London Airport', 
    city: 'London',
    country: 'United Kingdom',
    airports: ['LHR', 'LGW', 'LTN', 'STN', 'LCY', 'SEN']
  },
  { 
    code: 'NYC', 
    name: 'Any New York Airport', 
    city: 'New York',
    country: 'United States',
    airports: ['JFK', 'LGA', 'EWR']
  },
  { 
    code: 'PAR', 
    name: 'Any Paris Airport', 
    city: 'Paris',
    country: 'France',
    airports: ['CDG', 'ORY', 'BVA']
  },
  { 
    code: 'MIL', 
    name: 'Any Milan Airport', 
    city: 'Milan',
    country: 'Italy',
    airports: ['MXP', 'LIN', 'BGY']
  },
  { 
    code: 'ROM', 
    name: 'Any Rome Airport', 
    city: 'Rome',
    country: 'Italy',
    airports: ['FCO', 'CIA']
  },
  { 
    code: 'BER', 
    name: 'Any Berlin Airport', 
    city: 'Berlin',
    country: 'Germany',
    airports: ['BER']
  },
  { 
    code: 'STO', 
    name: 'Any Stockholm Airport', 
    city: 'Stockholm',
    country: 'Sweden',
    airports: ['ARN', 'BMA', 'NYO']
  },
  { 
    code: 'BRU', 
    name: 'Any Brussels Airport', 
    city: 'Brussels',
    country: 'Belgium',
    airports: ['BRU', 'CRL']
  },
  { 
    code: 'TYO', 
    name: 'Any Tokyo Airport', 
    city: 'Tokyo',
    country: 'Japan',
    airports: ['HND', 'NRT']
  },
  { 
    code: 'OSA', 
    name: 'Any Osaka Airport', 
    city: 'Osaka',
    country: 'Japan',
    airports: ['KIX', 'ITM']
  },
  { 
    code: 'SHA', 
    name: 'Any Shanghai Airport', 
    city: 'Shanghai',
    country: 'China',
    airports: ['PVG', 'SHA']
  },
  { 
    code: 'BJS', 
    name: 'Any Beijing Airport', 
    city: 'Beijing',
    country: 'China',
    airports: ['PEK', 'PKX']
  },
  { 
    code: 'BKK', 
    name: 'Any Bangkok Airport', 
    city: 'Bangkok',
    country: 'Thailand',
    airports: ['BKK', 'DMK']
  },
  { 
    code: 'SEL', 
    name: 'Any Seoul Airport', 
    city: 'Seoul',
    country: 'South Korea',
    airports: ['ICN', 'GMP']
  },
  { 
    code: 'IST', 
    name: 'Any Istanbul Airport', 
    city: 'Istanbul',
    country: 'Turkey',
    airports: ['IST', 'SAW']
  },
  { 
    code: 'DXB', 
    name: 'Any Dubai Airport', 
    city: 'Dubai',
    country: 'UAE',
    airports: ['DXB', 'DWC', 'SHJ']
  },
  { 
    code: 'SAO', 
    name: 'Any São Paulo Airport', 
    city: 'São Paulo',
    country: 'Brazil',
    airports: ['GRU', 'CGH', 'VCP']
  },
  { 
    code: 'RIO', 
    name: 'Any Rio de Janeiro Airport', 
    city: 'Rio de Janeiro',
    country: 'Brazil',
    airports: ['GIG', 'SDU']
  },
  { 
    code: 'BUE', 
    name: 'Any Buenos Aires Airport', 
    city: 'Buenos Aires',
    country: 'Argentina',
    airports: ['EZE', 'AEP']
  },
  { 
    code: 'JKT', 
    name: 'Any Jakarta Airport', 
    city: 'Jakarta',
    country: 'Indonesia',
    airports: ['CGK', 'HLP']
  },
  { 
    code: 'TPE', 
    name: 'Any Taipei Airport', 
    city: 'Taipei',
    country: 'Taiwan',
    airports: ['TPE', 'TSA']
  },
  { 
    code: 'WAS', 
    name: 'Any Washington DC Airport', 
    city: 'Washington DC',
    country: 'United States',
    airports: ['DCA', 'IAD', 'BWI']
  },
  { 
    code: 'CHI', 
    name: 'Any Chicago Airport', 
    city: 'Chicago',
    country: 'United States',
    airports: ['ORD', 'MDW']
  },
  { 
    code: 'MIA', 
    name: 'Any Miami Airport', 
    city: 'Miami',
    country: 'United States',
    airports: ['MIA', 'FLL', 'PBI']
  },
  { 
    code: 'LAX', 
    name: 'Any Los Angeles Airport', 
    city: 'Los Angeles',
    country: 'United States',
    airports: ['LAX', 'BUR', 'ONT', 'SNA', 'LGB']
  },
  { 
    code: 'SFO', 
    name: 'Any San Francisco Bay Area Airport', 
    city: 'San Francisco',
    country: 'United States',
    airports: ['SFO', 'OAK', 'SJC']
  },
  { 
    code: 'HOU', 
    name: 'Any Houston Airport', 
    city: 'Houston',
    country: 'United States',
    airports: ['IAH', 'HOU']
  },
  { 
    code: 'DAL', 
    name: 'Any Dallas Airport', 
    city: 'Dallas',
    country: 'United States',
    airports: ['DFW', 'DAL']
  },
  { 
    code: 'TOR', 
    name: 'Any Toronto Airport', 
    city: 'Toronto',
    country: 'Canada',
    airports: ['YYZ', 'YTZ']
  },
  { 
    code: 'MNL', 
    name: 'Any Manila Airport', 
    city: 'Manila',
    country: 'Philippines',
    airports: ['MNL', 'CRK']
  },
  { 
    code: 'MEL', 
    name: 'Any Melbourne Airport', 
    city: 'Melbourne',
    country: 'Australia',
    airports: ['MEL', 'AVV']
  },
  { 
    code: 'IND', 
    name: 'Any India Airport', 
    city: 'India',
    country: 'India',
    airports: ['DEL', 'BOM', 'BLR', 'HYD', 'MAA', 'CCU', 'GOI', 'COK', 'AMD', 'PNQ', 'JAI']
  },
  { 
    code: 'PAK', 
    name: 'Any Pakistan Airport', 
    city: 'Pakistan',
    country: 'Pakistan',
    airports: ['KHI', 'LHE', 'ISB']
  }
];